import { toValue as c, ref as G, onBeforeUnmount as ne, computed as A, watch as k, createElementBlock as he, openBlock as W, Fragment as zo, createElementVNode as re, withModifiers as Ge, renderSlot as Fe, normalizeStyle as ze, normalizeClass as Be, onMounted as De, nextTick as It, reactive as Wn, createCommentVNode as J, useCssVars as Gn, toDisplayString as Bo, createVNode as at, unref as Do, createBlock as oe, shallowRef as Uo, normalizeProps as Ko, mergeProps as jo } from "vue";
import { NebulaIcon as Ho } from "@discoveryedu/nebula-components";
var Fn = typeof global == "object" && global && global.Object === Object && global, No = typeof self == "object" && self && self.Object === Object && self, ue = Fn || No || Function("return this")(), te = ue.Symbol, Xn = Object.prototype, Wo = Xn.hasOwnProperty, Go = Xn.toString, He = te ? te.toStringTag : void 0;
function Fo(e) {
  var t = Wo.call(e, He), n = e[He];
  try {
    e[He] = void 0;
    var o = !0;
  } catch {
  }
  var i = Go.call(e);
  return o && (t ? e[He] = n : delete e[He]), i;
}
var Xo = Object.prototype, Yo = Xo.toString;
function ko(e) {
  return Yo.call(e);
}
var Zo = "[object Null]", qo = "[object Undefined]", an = te ? te.toStringTag : void 0;
function be(e) {
  return e == null ? e === void 0 ? qo : Zo : an && an in Object(e) ? Fo(e) : ko(e);
}
function ce(e) {
  return e != null && typeof e == "object";
}
var Vo = "[object Symbol]";
function Ae(e) {
  return typeof e == "symbol" || ce(e) && be(e) == Vo;
}
function Xe(e, t) {
  for (var n = -1, o = e == null ? 0 : e.length, i = Array(o); ++n < o; )
    i[n] = t(e[n], n, e);
  return i;
}
var X = Array.isArray, cn = te ? te.prototype : void 0, ln = cn ? cn.toString : void 0;
function Yn(e) {
  if (typeof e == "string")
    return e;
  if (X(e))
    return Xe(e, Yn) + "";
  if (Ae(e))
    return ln ? ln.call(e) : "";
  var t = e + "";
  return t == "0" && 1 / e == -1 / 0 ? "-0" : t;
}
var Jo = /\s/;
function Qo(e) {
  for (var t = e.length; t-- && Jo.test(e.charAt(t)); )
    ;
  return t;
}
var ei = /^\s+/;
function ti(e) {
  return e && e.slice(0, Qo(e) + 1).replace(ei, "");
}
function Q(e) {
  var t = typeof e;
  return e != null && (t == "object" || t == "function");
}
var un = NaN, ni = /^[-+]0x[0-9a-f]+$/i, oi = /^0b[01]+$/i, ii = /^0o[0-7]+$/i, ri = parseInt;
function dn(e) {
  if (typeof e == "number")
    return e;
  if (Ae(e))
    return un;
  if (Q(e)) {
    var t = typeof e.valueOf == "function" ? e.valueOf() : e;
    e = Q(t) ? t + "" : t;
  }
  if (typeof e != "string")
    return e === 0 ? e : +e;
  e = ti(e);
  var n = oi.test(e);
  return n || ii.test(e) ? ri(e.slice(2), n ? 2 : 8) : ni.test(e) ? un : +e;
}
function dt(e) {
  return e;
}
var si = "[object AsyncFunction]", ai = "[object Function]", ci = "[object GeneratorFunction]", li = "[object Proxy]";
function Ht(e) {
  if (!Q(e))
    return !1;
  var t = be(e);
  return t == ai || t == ci || t == si || t == li;
}
var Mt = ue["__core-js_shared__"], fn = function() {
  var e = /[^.]+$/.exec(Mt && Mt.keys && Mt.keys.IE_PROTO || "");
  return e ? "Symbol(src)_1." + e : "";
}();
function ui(e) {
  return !!fn && fn in e;
}
var di = Function.prototype, fi = di.toString;
function _e(e) {
  if (e != null) {
    try {
      return fi.call(e);
    } catch {
    }
    try {
      return e + "";
    } catch {
    }
  }
  return "";
}
var hi = /[\\^$.*+?()[\]{}|]/g, gi = /^\[object .+?Constructor\]$/, mi = Function.prototype, pi = Object.prototype, vi = mi.toString, yi = pi.hasOwnProperty, xi = RegExp(
  "^" + vi.call(yi).replace(hi, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function wi(e) {
  if (!Q(e) || ui(e))
    return !1;
  var t = Ht(e) ? xi : gi;
  return t.test(_e(e));
}
function bi(e, t) {
  return e == null ? void 0 : e[t];
}
function Re(e, t) {
  var n = bi(e, t);
  return wi(n) ? n : void 0;
}
var Pt = Re(ue, "WeakMap"), hn = Object.create, Ti = /* @__PURE__ */ function() {
  function e() {
  }
  return function(t) {
    if (!Q(t))
      return {};
    if (hn)
      return hn(t);
    e.prototype = t;
    var n = new e();
    return e.prototype = void 0, n;
  };
}();
function Mi(e, t, n) {
  switch (n.length) {
    case 0:
      return e.call(t);
    case 1:
      return e.call(t, n[0]);
    case 2:
      return e.call(t, n[0], n[1]);
    case 3:
      return e.call(t, n[0], n[1], n[2]);
  }
  return e.apply(t, n);
}
function _i(e, t) {
  var n = -1, o = e.length;
  for (t || (t = Array(o)); ++n < o; )
    t[n] = e[n];
  return t;
}
var Ri = 800, Si = 16, Ei = Date.now;
function Ii(e) {
  var t = 0, n = 0;
  return function() {
    var o = Ei(), i = Si - (o - n);
    if (n = o, i > 0) {
      if (++t >= Ri)
        return arguments[0];
    } else
      t = 0;
    return e.apply(void 0, arguments);
  };
}
function Pi(e) {
  return function() {
    return e;
  };
}
var ct = function() {
  try {
    var e = Re(Object, "defineProperty");
    return e({}, "", {}), e;
  } catch {
  }
}(), Li = ct ? function(e, t) {
  return ct(e, "toString", {
    configurable: !0,
    enumerable: !1,
    value: Pi(t),
    writable: !0
  });
} : dt, Oi = Ii(Li);
function Ci(e, t) {
  for (var n = -1, o = e == null ? 0 : e.length; ++n < o && t(e[n], n, e) !== !1; )
    ;
  return e;
}
function kn(e, t, n, o) {
  for (var i = e.length, r = n + (o ? 1 : -1); o ? r-- : ++r < i; )
    if (t(e[r], r, e))
      return r;
  return -1;
}
var Ai = 9007199254740991, $i = /^(?:0|[1-9]\d*)$/;
function Nt(e, t) {
  var n = typeof e;
  return t = t ?? Ai, !!t && (n == "number" || n != "symbol" && $i.test(e)) && e > -1 && e % 1 == 0 && e < t;
}
function Wt(e, t, n) {
  t == "__proto__" && ct ? ct(e, t, {
    configurable: !0,
    enumerable: !0,
    value: n,
    writable: !0
  }) : e[t] = n;
}
function tt(e, t) {
  return e === t || e !== e && t !== t;
}
var zi = Object.prototype, Bi = zi.hasOwnProperty;
function Zn(e, t, n) {
  var o = e[t];
  (!(Bi.call(e, t) && tt(o, n)) || n === void 0 && !(t in e)) && Wt(e, t, n);
}
function Di(e, t, n, o) {
  var i = !n;
  n || (n = {});
  for (var r = -1, a = t.length; ++r < a; ) {
    var l = t[r], d = void 0;
    d === void 0 && (d = e[l]), i ? Wt(n, l, d) : Zn(n, l, d);
  }
  return n;
}
var gn = Math.max;
function Ui(e, t, n) {
  return t = gn(t === void 0 ? e.length - 1 : t, 0), function() {
    for (var o = arguments, i = -1, r = gn(o.length - t, 0), a = Array(r); ++i < r; )
      a[i] = o[t + i];
    i = -1;
    for (var l = Array(t + 1); ++i < t; )
      l[i] = o[i];
    return l[t] = n(a), Mi(e, this, l);
  };
}
function Gt(e, t) {
  return Oi(Ui(e, t, dt), e + "");
}
var Ki = 9007199254740991;
function Ft(e) {
  return typeof e == "number" && e > -1 && e % 1 == 0 && e <= Ki;
}
function Ue(e) {
  return e != null && Ft(e.length) && !Ht(e);
}
function Lt(e, t, n) {
  if (!Q(n))
    return !1;
  var o = typeof t;
  return (o == "number" ? Ue(n) && Nt(t, n.length) : o == "string" && t in n) ? tt(n[t], e) : !1;
}
function ji(e) {
  return Gt(function(t, n) {
    var o = -1, i = n.length, r = i > 1 ? n[i - 1] : void 0, a = i > 2 ? n[2] : void 0;
    for (r = e.length > 3 && typeof r == "function" ? (i--, r) : void 0, a && Lt(n[0], n[1], a) && (r = i < 3 ? void 0 : r, i = 1), t = Object(t); ++o < i; ) {
      var l = n[o];
      l && e(t, l, o, r);
    }
    return t;
  });
}
var Hi = Object.prototype;
function Xt(e) {
  var t = e && e.constructor, n = typeof t == "function" && t.prototype || Hi;
  return e === n;
}
function Ni(e, t) {
  for (var n = -1, o = Array(e); ++n < e; )
    o[n] = t(n);
  return o;
}
var Wi = "[object Arguments]";
function mn(e) {
  return ce(e) && be(e) == Wi;
}
var qn = Object.prototype, Gi = qn.hasOwnProperty, Fi = qn.propertyIsEnumerable, ke = mn(/* @__PURE__ */ function() {
  return arguments;
}()) ? mn : function(e) {
  return ce(e) && Gi.call(e, "callee") && !Fi.call(e, "callee");
};
function Xi() {
  return !1;
}
var Vn = typeof exports == "object" && exports && !exports.nodeType && exports, pn = Vn && typeof module == "object" && module && !module.nodeType && module, Yi = pn && pn.exports === Vn, vn = Yi ? ue.Buffer : void 0, ki = vn ? vn.isBuffer : void 0, Ze = ki || Xi, Zi = "[object Arguments]", qi = "[object Array]", Vi = "[object Boolean]", Ji = "[object Date]", Qi = "[object Error]", er = "[object Function]", tr = "[object Map]", nr = "[object Number]", or = "[object Object]", ir = "[object RegExp]", rr = "[object Set]", sr = "[object String]", ar = "[object WeakMap]", cr = "[object ArrayBuffer]", lr = "[object DataView]", ur = "[object Float32Array]", dr = "[object Float64Array]", fr = "[object Int8Array]", hr = "[object Int16Array]", gr = "[object Int32Array]", mr = "[object Uint8Array]", pr = "[object Uint8ClampedArray]", vr = "[object Uint16Array]", yr = "[object Uint32Array]", N = {};
N[ur] = N[dr] = N[fr] = N[hr] = N[gr] = N[mr] = N[pr] = N[vr] = N[yr] = !0;
N[Zi] = N[qi] = N[cr] = N[Vi] = N[lr] = N[Ji] = N[Qi] = N[er] = N[tr] = N[nr] = N[or] = N[ir] = N[rr] = N[sr] = N[ar] = !1;
function xr(e) {
  return ce(e) && Ft(e.length) && !!N[be(e)];
}
function ft(e) {
  return function(t) {
    return e(t);
  };
}
var Jn = typeof exports == "object" && exports && !exports.nodeType && exports, Ye = Jn && typeof module == "object" && module && !module.nodeType && module, wr = Ye && Ye.exports === Jn, _t = wr && Fn.process, $e = function() {
  try {
    var e = Ye && Ye.require && Ye.require("util").types;
    return e || _t && _t.binding && _t.binding("util");
  } catch {
  }
}(), yn = $e && $e.isTypedArray, Yt = yn ? ft(yn) : xr, br = Object.prototype, Tr = br.hasOwnProperty;
function Qn(e, t) {
  var n = X(e), o = !n && ke(e), i = !n && !o && Ze(e), r = !n && !o && !i && Yt(e), a = n || o || i || r, l = a ? Ni(e.length, String) : [], d = l.length;
  for (var f in e)
    (t || Tr.call(e, f)) && !(a && // Safari 9 has enumerable `arguments.length` in strict mode.
    (f == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    i && (f == "offset" || f == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    r && (f == "buffer" || f == "byteLength" || f == "byteOffset") || // Skip index properties.
    Nt(f, d))) && l.push(f);
  return l;
}
function eo(e, t) {
  return function(n) {
    return e(t(n));
  };
}
var Mr = eo(Object.keys, Object), _r = Object.prototype, Rr = _r.hasOwnProperty;
function Sr(e) {
  if (!Xt(e))
    return Mr(e);
  var t = [];
  for (var n in Object(e))
    Rr.call(e, n) && n != "constructor" && t.push(n);
  return t;
}
function kt(e) {
  return Ue(e) ? Qn(e) : Sr(e);
}
function Er(e) {
  var t = [];
  if (e != null)
    for (var n in Object(e))
      t.push(n);
  return t;
}
var Ir = Object.prototype, Pr = Ir.hasOwnProperty;
function Lr(e) {
  if (!Q(e))
    return Er(e);
  var t = Xt(e), n = [];
  for (var o in e)
    o == "constructor" && (t || !Pr.call(e, o)) || n.push(o);
  return n;
}
function to(e) {
  return Ue(e) ? Qn(e, !0) : Lr(e);
}
var Or = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, Cr = /^\w*$/;
function Zt(e, t) {
  if (X(e))
    return !1;
  var n = typeof e;
  return n == "number" || n == "symbol" || n == "boolean" || e == null || Ae(e) ? !0 : Cr.test(e) || !Or.test(e) || t != null && e in Object(t);
}
var qe = Re(Object, "create");
function Ar() {
  this.__data__ = qe ? qe(null) : {}, this.size = 0;
}
function $r(e) {
  var t = this.has(e) && delete this.__data__[e];
  return this.size -= t ? 1 : 0, t;
}
var zr = "__lodash_hash_undefined__", Br = Object.prototype, Dr = Br.hasOwnProperty;
function Ur(e) {
  var t = this.__data__;
  if (qe) {
    var n = t[e];
    return n === zr ? void 0 : n;
  }
  return Dr.call(t, e) ? t[e] : void 0;
}
var Kr = Object.prototype, jr = Kr.hasOwnProperty;
function Hr(e) {
  var t = this.__data__;
  return qe ? t[e] !== void 0 : jr.call(t, e);
}
var Nr = "__lodash_hash_undefined__";
function Wr(e, t) {
  var n = this.__data__;
  return this.size += this.has(e) ? 0 : 1, n[e] = qe && t === void 0 ? Nr : t, this;
}
function Me(e) {
  var t = -1, n = e == null ? 0 : e.length;
  for (this.clear(); ++t < n; ) {
    var o = e[t];
    this.set(o[0], o[1]);
  }
}
Me.prototype.clear = Ar;
Me.prototype.delete = $r;
Me.prototype.get = Ur;
Me.prototype.has = Hr;
Me.prototype.set = Wr;
function Gr() {
  this.__data__ = [], this.size = 0;
}
function ht(e, t) {
  for (var n = e.length; n--; )
    if (tt(e[n][0], t))
      return n;
  return -1;
}
var Fr = Array.prototype, Xr = Fr.splice;
function Yr(e) {
  var t = this.__data__, n = ht(t, e);
  if (n < 0)
    return !1;
  var o = t.length - 1;
  return n == o ? t.pop() : Xr.call(t, n, 1), --this.size, !0;
}
function kr(e) {
  var t = this.__data__, n = ht(t, e);
  return n < 0 ? void 0 : t[n][1];
}
function Zr(e) {
  return ht(this.__data__, e) > -1;
}
function qr(e, t) {
  var n = this.__data__, o = ht(n, e);
  return o < 0 ? (++this.size, n.push([e, t])) : n[o][1] = t, this;
}
function pe(e) {
  var t = -1, n = e == null ? 0 : e.length;
  for (this.clear(); ++t < n; ) {
    var o = e[t];
    this.set(o[0], o[1]);
  }
}
pe.prototype.clear = Gr;
pe.prototype.delete = Yr;
pe.prototype.get = kr;
pe.prototype.has = Zr;
pe.prototype.set = qr;
var Ve = Re(ue, "Map");
function Vr() {
  this.size = 0, this.__data__ = {
    hash: new Me(),
    map: new (Ve || pe)(),
    string: new Me()
  };
}
function Jr(e) {
  var t = typeof e;
  return t == "string" || t == "number" || t == "symbol" || t == "boolean" ? e !== "__proto__" : e === null;
}
function gt(e, t) {
  var n = e.__data__;
  return Jr(t) ? n[typeof t == "string" ? "string" : "hash"] : n.map;
}
function Qr(e) {
  var t = gt(this, e).delete(e);
  return this.size -= t ? 1 : 0, t;
}
function es(e) {
  return gt(this, e).get(e);
}
function ts(e) {
  return gt(this, e).has(e);
}
function ns(e, t) {
  var n = gt(this, e), o = n.size;
  return n.set(e, t), this.size += n.size == o ? 0 : 1, this;
}
function ve(e) {
  var t = -1, n = e == null ? 0 : e.length;
  for (this.clear(); ++t < n; ) {
    var o = e[t];
    this.set(o[0], o[1]);
  }
}
ve.prototype.clear = Vr;
ve.prototype.delete = Qr;
ve.prototype.get = es;
ve.prototype.has = ts;
ve.prototype.set = ns;
var os = "Expected a function";
function qt(e, t) {
  if (typeof e != "function" || t != null && typeof t != "function")
    throw new TypeError(os);
  var n = function() {
    var o = arguments, i = t ? t.apply(this, o) : o[0], r = n.cache;
    if (r.has(i))
      return r.get(i);
    var a = e.apply(this, o);
    return n.cache = r.set(i, a) || r, a;
  };
  return n.cache = new (qt.Cache || ve)(), n;
}
qt.Cache = ve;
var is = 500;
function rs(e) {
  var t = qt(e, function(o) {
    return n.size === is && n.clear(), o;
  }), n = t.cache;
  return t;
}
var ss = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, as = /\\(\\)?/g, cs = rs(function(e) {
  var t = [];
  return e.charCodeAt(0) === 46 && t.push(""), e.replace(ss, function(n, o, i, r) {
    t.push(i ? r.replace(as, "$1") : o || n);
  }), t;
});
function ls(e) {
  return e == null ? "" : Yn(e);
}
function no(e, t) {
  return X(e) ? e : Zt(e, t) ? [e] : cs(ls(e));
}
function mt(e) {
  if (typeof e == "string" || Ae(e))
    return e;
  var t = e + "";
  return t == "0" && 1 / e == -1 / 0 ? "-0" : t;
}
function Vt(e, t) {
  t = no(t, e);
  for (var n = 0, o = t.length; e != null && n < o; )
    e = e[mt(t[n++])];
  return n && n == o ? e : void 0;
}
function pt(e, t, n) {
  var o = e == null ? void 0 : Vt(e, t);
  return o === void 0 ? n : o;
}
function oo(e, t) {
  for (var n = -1, o = t.length, i = e.length; ++n < o; )
    e[i + n] = t[n];
  return e;
}
var xn = te ? te.isConcatSpreadable : void 0;
function us(e) {
  return X(e) || ke(e) || !!(xn && e && e[xn]);
}
function io(e, t, n, o, i) {
  var r = -1, a = e.length;
  for (n || (n = us), i || (i = []); ++r < a; ) {
    var l = e[r];
    n(l) ? oo(i, l) : i[i.length] = l;
  }
  return i;
}
function ds(e) {
  var t = e == null ? 0 : e.length;
  return t ? io(e) : [];
}
var ro = eo(Object.getPrototypeOf, Object), fs = "[object Object]", hs = Function.prototype, gs = Object.prototype, so = hs.toString, ms = gs.hasOwnProperty, ps = so.call(Object);
function vs(e) {
  if (!ce(e) || be(e) != fs)
    return !1;
  var t = ro(e);
  if (t === null)
    return !0;
  var n = ms.call(t, "constructor") && t.constructor;
  return typeof n == "function" && n instanceof n && so.call(n) == ps;
}
function ys(e, t, n, o) {
  var i = -1, r = e == null ? 0 : e.length;
  for (o && r && (n = e[++i]); ++i < r; )
    n = t(n, e[i], i, e);
  return n;
}
function xs() {
  this.__data__ = new pe(), this.size = 0;
}
function ws(e) {
  var t = this.__data__, n = t.delete(e);
  return this.size = t.size, n;
}
function bs(e) {
  return this.__data__.get(e);
}
function Ts(e) {
  return this.__data__.has(e);
}
var Ms = 200;
function _s(e, t) {
  var n = this.__data__;
  if (n instanceof pe) {
    var o = n.__data__;
    if (!Ve || o.length < Ms - 1)
      return o.push([e, t]), this.size = ++n.size, this;
    n = this.__data__ = new ve(o);
  }
  return n.set(e, t), this.size = n.size, this;
}
function ae(e) {
  var t = this.__data__ = new pe(e);
  this.size = t.size;
}
ae.prototype.clear = xs;
ae.prototype.delete = ws;
ae.prototype.get = bs;
ae.prototype.has = Ts;
ae.prototype.set = _s;
var ao = typeof exports == "object" && exports && !exports.nodeType && exports, wn = ao && typeof module == "object" && module && !module.nodeType && module, Rs = wn && wn.exports === ao, bn = Rs ? ue.Buffer : void 0, Tn = bn ? bn.allocUnsafe : void 0;
function co(e, t) {
  if (t)
    return e.slice();
  var n = e.length, o = Tn ? Tn(n) : new e.constructor(n);
  return e.copy(o), o;
}
function Ss(e, t) {
  for (var n = -1, o = e == null ? 0 : e.length, i = 0, r = []; ++n < o; ) {
    var a = e[n];
    t(a, n, e) && (r[i++] = a);
  }
  return r;
}
function Es() {
  return [];
}
var Is = Object.prototype, Ps = Is.propertyIsEnumerable, Mn = Object.getOwnPropertySymbols, Ls = Mn ? function(e) {
  return e == null ? [] : (e = Object(e), Ss(Mn(e), function(t) {
    return Ps.call(e, t);
  }));
} : Es;
function Os(e, t, n) {
  var o = t(e);
  return X(e) ? o : oo(o, n(e));
}
function Ot(e) {
  return Os(e, kt, Ls);
}
var Ct = Re(ue, "DataView"), At = Re(ue, "Promise"), $t = Re(ue, "Set"), _n = "[object Map]", Cs = "[object Object]", Rn = "[object Promise]", Sn = "[object Set]", En = "[object WeakMap]", In = "[object DataView]", As = _e(Ct), $s = _e(Ve), zs = _e(At), Bs = _e($t), Ds = _e(Pt), se = be;
(Ct && se(new Ct(new ArrayBuffer(1))) != In || Ve && se(new Ve()) != _n || At && se(At.resolve()) != Rn || $t && se(new $t()) != Sn || Pt && se(new Pt()) != En) && (se = function(e) {
  var t = be(e), n = t == Cs ? e.constructor : void 0, o = n ? _e(n) : "";
  if (o)
    switch (o) {
      case As:
        return In;
      case $s:
        return _n;
      case zs:
        return Rn;
      case Bs:
        return Sn;
      case Ds:
        return En;
    }
  return t;
});
var Us = Object.prototype, Ks = Us.hasOwnProperty;
function js(e) {
  var t = e.length, n = new e.constructor(t);
  return t && typeof e[0] == "string" && Ks.call(e, "index") && (n.index = e.index, n.input = e.input), n;
}
var lt = ue.Uint8Array;
function Jt(e) {
  var t = new e.constructor(e.byteLength);
  return new lt(t).set(new lt(e)), t;
}
function Hs(e, t) {
  var n = Jt(e.buffer);
  return new e.constructor(n, e.byteOffset, e.byteLength);
}
var Ns = /\w*$/;
function Ws(e) {
  var t = new e.constructor(e.source, Ns.exec(e));
  return t.lastIndex = e.lastIndex, t;
}
var Pn = te ? te.prototype : void 0, Ln = Pn ? Pn.valueOf : void 0;
function Gs(e) {
  return Ln ? Object(Ln.call(e)) : {};
}
function lo(e, t) {
  var n = t ? Jt(e.buffer) : e.buffer;
  return new e.constructor(n, e.byteOffset, e.length);
}
var Fs = "[object Boolean]", Xs = "[object Date]", Ys = "[object Map]", ks = "[object Number]", Zs = "[object RegExp]", qs = "[object Set]", Vs = "[object String]", Js = "[object Symbol]", Qs = "[object ArrayBuffer]", ea = "[object DataView]", ta = "[object Float32Array]", na = "[object Float64Array]", oa = "[object Int8Array]", ia = "[object Int16Array]", ra = "[object Int32Array]", sa = "[object Uint8Array]", aa = "[object Uint8ClampedArray]", ca = "[object Uint16Array]", la = "[object Uint32Array]";
function ua(e, t, n) {
  var o = e.constructor;
  switch (t) {
    case Qs:
      return Jt(e);
    case Fs:
    case Xs:
      return new o(+e);
    case ea:
      return Hs(e);
    case ta:
    case na:
    case oa:
    case ia:
    case ra:
    case sa:
    case aa:
    case ca:
    case la:
      return lo(e, n);
    case Ys:
      return new o();
    case ks:
    case Vs:
      return new o(e);
    case Zs:
      return Ws(e);
    case qs:
      return new o();
    case Js:
      return Gs(e);
  }
}
function uo(e) {
  return typeof e.constructor == "function" && !Xt(e) ? Ti(ro(e)) : {};
}
var da = "[object Map]";
function fa(e) {
  return ce(e) && se(e) == da;
}
var On = $e && $e.isMap, ha = On ? ft(On) : fa, ga = "[object Set]";
function ma(e) {
  return ce(e) && se(e) == ga;
}
var Cn = $e && $e.isSet, pa = Cn ? ft(Cn) : ma, va = 1, fo = "[object Arguments]", ya = "[object Array]", xa = "[object Boolean]", wa = "[object Date]", ba = "[object Error]", ho = "[object Function]", Ta = "[object GeneratorFunction]", Ma = "[object Map]", _a = "[object Number]", go = "[object Object]", Ra = "[object RegExp]", Sa = "[object Set]", Ea = "[object String]", Ia = "[object Symbol]", Pa = "[object WeakMap]", La = "[object ArrayBuffer]", Oa = "[object DataView]", Ca = "[object Float32Array]", Aa = "[object Float64Array]", $a = "[object Int8Array]", za = "[object Int16Array]", Ba = "[object Int32Array]", Da = "[object Uint8Array]", Ua = "[object Uint8ClampedArray]", Ka = "[object Uint16Array]", ja = "[object Uint32Array]", H = {};
H[fo] = H[ya] = H[La] = H[Oa] = H[xa] = H[wa] = H[Ca] = H[Aa] = H[$a] = H[za] = H[Ba] = H[Ma] = H[_a] = H[go] = H[Ra] = H[Sa] = H[Ea] = H[Ia] = H[Da] = H[Ua] = H[Ka] = H[ja] = !0;
H[ba] = H[ho] = H[Pa] = !1;
function st(e, t, n, o, i, r) {
  var a, l = t & va;
  if (a !== void 0)
    return a;
  if (!Q(e))
    return e;
  var d = X(e);
  if (d)
    a = js(e);
  else {
    var f = se(e), b = f == ho || f == Ta;
    if (Ze(e))
      return co(e, l);
    if (f == go || f == fo || b && !i)
      a = b ? {} : uo(e);
    else {
      if (!H[f])
        return i ? e : {};
      a = ua(e, f, l);
    }
  }
  r || (r = new ae());
  var x = r.get(e);
  if (x)
    return x;
  r.set(e, a), pa(e) ? e.forEach(function(R) {
    a.add(st(R, t, n, R, e, r));
  }) : ha(e) && e.forEach(function(R, L) {
    a.set(L, st(R, t, n, L, e, r));
  });
  var w = Ot, S = d ? void 0 : w(e);
  return Ci(S || e, function(R, L) {
    S && (L = R, R = e[L]), Zn(a, L, st(R, t, n, L, e, r));
  }), a;
}
var Ha = 1, Na = 4;
function xe(e) {
  return st(e, Ha | Na);
}
var Wa = "__lodash_hash_undefined__";
function Ga(e) {
  return this.__data__.set(e, Wa), this;
}
function Fa(e) {
  return this.__data__.has(e);
}
function ut(e) {
  var t = -1, n = e == null ? 0 : e.length;
  for (this.__data__ = new ve(); ++t < n; )
    this.add(e[t]);
}
ut.prototype.add = ut.prototype.push = Ga;
ut.prototype.has = Fa;
function Xa(e, t) {
  for (var n = -1, o = e == null ? 0 : e.length; ++n < o; )
    if (t(e[n], n, e))
      return !0;
  return !1;
}
function Ya(e, t) {
  return e.has(t);
}
var ka = 1, Za = 2;
function mo(e, t, n, o, i, r) {
  var a = n & ka, l = e.length, d = t.length;
  if (l != d && !(a && d > l))
    return !1;
  var f = r.get(e), b = r.get(t);
  if (f && b)
    return f == t && b == e;
  var x = -1, w = !0, S = n & Za ? new ut() : void 0;
  for (r.set(e, t), r.set(t, e); ++x < l; ) {
    var R = e[x], L = t[x];
    if (o)
      var T = a ? o(L, R, x, t, e, r) : o(R, L, x, e, t, r);
    if (T !== void 0) {
      if (T)
        continue;
      w = !1;
      break;
    }
    if (S) {
      if (!Xa(t, function(E, v) {
        if (!Ya(S, v) && (R === E || i(R, E, n, o, r)))
          return S.push(v);
      })) {
        w = !1;
        break;
      }
    } else if (!(R === L || i(R, L, n, o, r))) {
      w = !1;
      break;
    }
  }
  return r.delete(e), r.delete(t), w;
}
function qa(e) {
  var t = -1, n = Array(e.size);
  return e.forEach(function(o, i) {
    n[++t] = [i, o];
  }), n;
}
function Va(e) {
  var t = -1, n = Array(e.size);
  return e.forEach(function(o) {
    n[++t] = o;
  }), n;
}
var Ja = 1, Qa = 2, ec = "[object Boolean]", tc = "[object Date]", nc = "[object Error]", oc = "[object Map]", ic = "[object Number]", rc = "[object RegExp]", sc = "[object Set]", ac = "[object String]", cc = "[object Symbol]", lc = "[object ArrayBuffer]", uc = "[object DataView]", An = te ? te.prototype : void 0, Rt = An ? An.valueOf : void 0;
function dc(e, t, n, o, i, r, a) {
  switch (n) {
    case uc:
      if (e.byteLength != t.byteLength || e.byteOffset != t.byteOffset)
        return !1;
      e = e.buffer, t = t.buffer;
    case lc:
      return !(e.byteLength != t.byteLength || !r(new lt(e), new lt(t)));
    case ec:
    case tc:
    case ic:
      return tt(+e, +t);
    case nc:
      return e.name == t.name && e.message == t.message;
    case rc:
    case ac:
      return e == t + "";
    case oc:
      var l = qa;
    case sc:
      var d = o & Ja;
      if (l || (l = Va), e.size != t.size && !d)
        return !1;
      var f = a.get(e);
      if (f)
        return f == t;
      o |= Qa, a.set(e, t);
      var b = mo(l(e), l(t), o, i, r, a);
      return a.delete(e), b;
    case cc:
      if (Rt)
        return Rt.call(e) == Rt.call(t);
  }
  return !1;
}
var fc = 1, hc = Object.prototype, gc = hc.hasOwnProperty;
function mc(e, t, n, o, i, r) {
  var a = n & fc, l = Ot(e), d = l.length, f = Ot(t), b = f.length;
  if (d != b && !a)
    return !1;
  for (var x = d; x--; ) {
    var w = l[x];
    if (!(a ? w in t : gc.call(t, w)))
      return !1;
  }
  var S = r.get(e), R = r.get(t);
  if (S && R)
    return S == t && R == e;
  var L = !0;
  r.set(e, t), r.set(t, e);
  for (var T = a; ++x < d; ) {
    w = l[x];
    var E = e[w], v = t[w];
    if (o)
      var y = a ? o(v, E, w, t, e, r) : o(E, v, w, e, t, r);
    if (!(y === void 0 ? E === v || i(E, v, n, o, r) : y)) {
      L = !1;
      break;
    }
    T || (T = w == "constructor");
  }
  if (L && !T) {
    var p = e.constructor, u = t.constructor;
    p != u && "constructor" in e && "constructor" in t && !(typeof p == "function" && p instanceof p && typeof u == "function" && u instanceof u) && (L = !1);
  }
  return r.delete(e), r.delete(t), L;
}
var pc = 1, $n = "[object Arguments]", zn = "[object Array]", ot = "[object Object]", vc = Object.prototype, Bn = vc.hasOwnProperty;
function yc(e, t, n, o, i, r) {
  var a = X(e), l = X(t), d = a ? zn : se(e), f = l ? zn : se(t);
  d = d == $n ? ot : d, f = f == $n ? ot : f;
  var b = d == ot, x = f == ot, w = d == f;
  if (w && Ze(e)) {
    if (!Ze(t))
      return !1;
    a = !0, b = !1;
  }
  if (w && !b)
    return r || (r = new ae()), a || Yt(e) ? mo(e, t, n, o, i, r) : dc(e, t, d, n, o, i, r);
  if (!(n & pc)) {
    var S = b && Bn.call(e, "__wrapped__"), R = x && Bn.call(t, "__wrapped__");
    if (S || R) {
      var L = S ? e.value() : e, T = R ? t.value() : t;
      return r || (r = new ae()), i(L, T, n, o, r);
    }
  }
  return w ? (r || (r = new ae()), mc(e, t, n, o, i, r)) : !1;
}
function vt(e, t, n, o, i) {
  return e === t ? !0 : e == null || t == null || !ce(e) && !ce(t) ? e !== e && t !== t : yc(e, t, n, o, vt, i);
}
var xc = 1, wc = 2;
function bc(e, t, n, o) {
  var i = n.length, r = i;
  if (e == null)
    return !r;
  for (e = Object(e); i--; ) {
    var a = n[i];
    if (a[2] ? a[1] !== e[a[0]] : !(a[0] in e))
      return !1;
  }
  for (; ++i < r; ) {
    a = n[i];
    var l = a[0], d = e[l], f = a[1];
    if (a[2]) {
      if (d === void 0 && !(l in e))
        return !1;
    } else {
      var b = new ae(), x;
      if (!(x === void 0 ? vt(f, d, xc | wc, o, b) : x))
        return !1;
    }
  }
  return !0;
}
function po(e) {
  return e === e && !Q(e);
}
function Tc(e) {
  for (var t = kt(e), n = t.length; n--; ) {
    var o = t[n], i = e[o];
    t[n] = [o, i, po(i)];
  }
  return t;
}
function vo(e, t) {
  return function(n) {
    return n == null ? !1 : n[e] === t && (t !== void 0 || e in Object(n));
  };
}
function Mc(e) {
  var t = Tc(e);
  return t.length == 1 && t[0][2] ? vo(t[0][0], t[0][1]) : function(n) {
    return n === e || bc(n, e, t);
  };
}
function _c(e, t) {
  return e != null && t in Object(e);
}
function Rc(e, t, n) {
  t = no(t, e);
  for (var o = -1, i = t.length, r = !1; ++o < i; ) {
    var a = mt(t[o]);
    if (!(r = e != null && n(e, a)))
      break;
    e = e[a];
  }
  return r || ++o != i ? r : (i = e == null ? 0 : e.length, !!i && Ft(i) && Nt(a, i) && (X(e) || ke(e)));
}
function Sc(e, t) {
  return e != null && Rc(e, t, _c);
}
var Ec = 1, Ic = 2;
function Pc(e, t) {
  return Zt(e) && po(t) ? vo(mt(e), t) : function(n) {
    var o = pt(n, e);
    return o === void 0 && o === t ? Sc(n, e) : vt(t, o, Ec | Ic);
  };
}
function Lc(e) {
  return function(t) {
    return t == null ? void 0 : t[e];
  };
}
function Oc(e) {
  return function(t) {
    return Vt(t, e);
  };
}
function Cc(e) {
  return Zt(e) ? Lc(mt(e)) : Oc(e);
}
function nt(e) {
  return typeof e == "function" ? e : e == null ? dt : typeof e == "object" ? X(e) ? Pc(e[0], e[1]) : Mc(e) : Cc(e);
}
function Ac(e) {
  return function(t, n, o) {
    for (var i = -1, r = Object(t), a = o(t), l = a.length; l--; ) {
      var d = a[++i];
      if (n(r[d], d, r) === !1)
        break;
    }
    return t;
  };
}
var yo = Ac();
function $c(e, t) {
  return e && yo(e, t, kt);
}
function zc(e, t) {
  return function(n, o) {
    if (n == null)
      return n;
    if (!Ue(n))
      return e(n, o);
    for (var i = n.length, r = -1, a = Object(n); ++r < i && o(a[r], r, a) !== !1; )
      ;
    return n;
  };
}
var xo = zc($c), St = function() {
  return ue.Date.now();
}, Bc = "Expected a function", Dc = Math.max, Uc = Math.min;
function Kc(e, t, n) {
  var o, i, r, a, l, d, f = 0, b = !1, x = !1, w = !0;
  if (typeof e != "function")
    throw new TypeError(Bc);
  t = dn(t) || 0, Q(n) && (b = !!n.leading, x = "maxWait" in n, r = x ? Dc(dn(n.maxWait) || 0, t) : r, w = "trailing" in n ? !!n.trailing : w);
  function S(s) {
    var g = o, h = i;
    return o = i = void 0, f = s, a = e.apply(h, g), a;
  }
  function R(s) {
    return f = s, l = setTimeout(E, t), b ? S(s) : a;
  }
  function L(s) {
    var g = s - d, h = s - f, m = t - g;
    return x ? Uc(m, r - h) : m;
  }
  function T(s) {
    var g = s - d, h = s - f;
    return d === void 0 || g >= t || g < 0 || x && h >= r;
  }
  function E() {
    var s = St();
    if (T(s))
      return v(s);
    l = setTimeout(E, L(s));
  }
  function v(s) {
    return l = void 0, w && o ? S(s) : (o = i = void 0, a);
  }
  function y() {
    l !== void 0 && clearTimeout(l), f = 0, o = d = i = l = void 0;
  }
  function p() {
    return l === void 0 ? a : v(St());
  }
  function u() {
    var s = St(), g = T(s);
    if (o = arguments, i = this, d = s, g) {
      if (l === void 0)
        return R(d);
      if (x)
        return clearTimeout(l), l = setTimeout(E, t), S(d);
    }
    return l === void 0 && (l = setTimeout(E, t)), a;
  }
  return u.cancel = y, u.flush = p, u;
}
function zt(e, t, n) {
  (n !== void 0 && !tt(e[t], n) || n === void 0 && !(t in e)) && Wt(e, t, n);
}
function jc(e) {
  return ce(e) && Ue(e);
}
function Bt(e, t) {
  if (!(t === "constructor" && typeof e[t] == "function") && t != "__proto__")
    return e[t];
}
function Hc(e) {
  return Di(e, to(e));
}
function Nc(e, t, n, o, i, r, a) {
  var l = Bt(e, n), d = Bt(t, n), f = a.get(d);
  if (f) {
    zt(e, n, f);
    return;
  }
  var b = r ? r(l, d, n + "", e, t, a) : void 0, x = b === void 0;
  if (x) {
    var w = X(d), S = !w && Ze(d), R = !w && !S && Yt(d);
    b = d, w || S || R ? X(l) ? b = l : jc(l) ? b = _i(l) : S ? (x = !1, b = co(d, !0)) : R ? (x = !1, b = lo(d, !0)) : b = [] : vs(d) || ke(d) ? (b = l, ke(l) ? b = Hc(l) : (!Q(l) || Ht(l)) && (b = uo(d))) : x = !1;
  }
  x && (a.set(d, b), i(b, d, o, r, a), a.delete(d)), zt(e, n, b);
}
function wo(e, t, n, o, i) {
  e !== t && yo(t, function(r, a) {
    if (i || (i = new ae()), Q(r))
      Nc(e, t, a, n, wo, o, i);
    else {
      var l = o ? o(Bt(e, a), r, a + "", e, t, i) : void 0;
      l === void 0 && (l = r), zt(e, a, l);
    }
  }, to);
}
var Wc = ji(function(e, t, n, o) {
  wo(e, t, n, o);
}), Gc = "Expected a function";
function Fc(e, t, n) {
  if (typeof e != "function")
    throw new TypeError(Gc);
  return setTimeout(function() {
    e.apply(void 0, n);
  }, t);
}
var Xc = Gt(function(e, t) {
  return Fc(e, 1, t);
});
function Dt(e) {
  var t = e == null ? 0 : e.length;
  return t ? e[t - 1] : void 0;
}
function Dn(e, t, n) {
  var o = e == null ? 0 : e.length;
  if (!o)
    return -1;
  var i = 0;
  return kn(e, nt(t), i);
}
function Un(e, t, n) {
  var o = e == null ? 0 : e.length;
  if (!o)
    return -1;
  var i = o - 1;
  return kn(e, nt(t), i, !0);
}
function ee(e) {
  return e && e.length ? e[0] : void 0;
}
function bo(e, t) {
  var n = -1, o = Ue(e) ? Array(e.length) : [];
  return xo(e, function(i, r, a) {
    o[++n] = t(i, r, a);
  }), o;
}
function To(e, t) {
  var n = X(e) ? Xe : bo;
  return n(e, nt(t));
}
function Yc(e, t) {
  return vt(e, t);
}
var kc = "[object Number]";
function ie(e) {
  return typeof e == "number" || ce(e) && be(e) == kc;
}
function Mo(e) {
  return e == null;
}
function Zc(e, t) {
  var n = e.length;
  for (e.sort(t); n--; )
    e[n] = e[n].value;
  return e;
}
function qc(e, t) {
  if (e !== t) {
    var n = e !== void 0, o = e === null, i = e === e, r = Ae(e), a = t !== void 0, l = t === null, d = t === t, f = Ae(t);
    if (!l && !f && !r && e > t || r && a && d && !l && !f || o && a && d || !n && d || !i)
      return 1;
    if (!o && !r && !f && e < t || f && n && i && !o && !r || l && n && i || !a && i || !d)
      return -1;
  }
  return 0;
}
function Vc(e, t, n) {
  for (var o = -1, i = e.criteria, r = t.criteria, a = i.length, l = n.length; ++o < a; ) {
    var d = qc(i[o], r[o]);
    if (d) {
      if (o >= l)
        return d;
      var f = n[o];
      return d * (f == "desc" ? -1 : 1);
    }
  }
  return e.index - t.index;
}
function Jc(e, t, n) {
  t.length ? t = Xe(t, function(r) {
    return X(r) ? function(a) {
      return Vt(a, r.length === 1 ? r[0] : r);
    } : r;
  }) : t = [dt];
  var o = -1;
  t = Xe(t, ft(nt));
  var i = bo(e, function(r, a, l) {
    var d = Xe(t, function(f) {
      return f(r);
    });
    return { criteria: d, index: ++o, value: r };
  });
  return Zc(i, function(r, a) {
    return Vc(r, a, n);
  });
}
function Qc(e, t, n, o, i) {
  return i(e, function(r, a, l) {
    n = o ? (o = !1, r) : t(n, r, a, l);
  }), n;
}
function el(e, t, n) {
  var o = X(e) ? ys : Qc, i = arguments.length < 3;
  return o(e, nt(t), n, i, xo);
}
var me = Gt(function(e, t) {
  if (e == null)
    return [];
  var n = t.length;
  return n > 1 && Lt(e, t[0], t[1]) ? t = [] : n > 2 && Lt(t[0], t[1], t[2]) && (t = [t[0]]), Jc(e, io(t), []);
}), tl = "Expected a function";
function we(e, t, n) {
  var o = !0, i = !0;
  if (typeof e != "function")
    throw new TypeError(tl);
  return Q(n) && (o = "leading" in n ? !!n.leading : o, i = "trailing" in n ? !!n.trailing : i), Kc(e, t, {
    leading: o,
    maxWait: t,
    trailing: i
  });
}
const We = "pixels", Ke = 25, nl = "titan-grid-layout", _o = "titan-grid-item", ol = "titan-grid-item-before", il = "titan-grid-item-after", rl = "data-titan-grid-item-menu-for-id", sl = "titan-grid-resize-handle", al = "titan-grid-rotation__handle", Ut = `
  .${_o},
  .${ol},
  .${il},
  .${al},
  .${sl}
`, Je = { width: 1, height: 1 }, it = 10, cl = 36, rt = 15, ll = {
  top: "ns-resize",
  right: "ew-resize",
  bottom: "ns-resize",
  left: "ew-resize",
  "top-left": "nwse-resize",
  "top-right": "nesw-resize",
  "bottom-right": "nwse-resize",
  "bottom-left": "nesw-resize"
}, Kn = "data-titan-grid-id", ul = '.titan-grid-selection-box__ignore, button, input, select, textarea, [contenteditable="true"]', jn = "titan-grid-selection-box__selection-container", dl = 'textarea, input, select, button, a, [contenteditable="true"]', fl = 'textarea, select, input, button, a, [contenteditable="true"]', Te = {
  cellWidth: 20,
  cellHeight: 20,
  cellLargeWidthCellCount: 5,
  cellLargeHeightCellCount: 5,
  cellLineWidth: 0.5,
  largeCellLineWidth: 1
}, hl = {
  selection: {
    multipleSelect: [{ modKeys: ["shiftKey"] }]
  },
  rotate: {
    snapTo15: [{ modKeys: ["shiftKey"] }]
  },
  resize: {
    keepAspectRatio: [{ modKeys: ["shiftKey"], isExclusive: !1 }],
    resizeOnCenter: [{ modKeys: ["ctrlKey"], isExclusive: !1 }]
  },
  move: {
    moveXOnly: [{ modKeys: ["ctrlKey"] }],
    moveYOnly: [{ modKeys: ["altKey"] }],
    snapGrid: {
      snapToLeft: [{ modKeys: ["ctrlKey"], isExclusive: !1 }],
      snapToTop: [{ modKeys: ["altKey"], isExclusive: !1 }]
    },
    moveToFront: [
      { keyCode: 38, modKeys: ["ctrlKey", "altKey"] }
      // Arrow Up
    ],
    moveForward: [
      { keyCode: 38, modKeys: ["altKey"] }
      // Arrow Up
    ],
    moveBackward: [
      { keyCode: 40, modKeys: ["altKey"] }
      // Arrow Down
    ],
    moveToBack: [
      { keyCode: 40, modKeys: ["ctrlKey", "altKey"] }
      // Arrow Down
    ],
    moveUp: [
      { keyCode: 38 }
      // Arrow Up
    ],
    moveDown: [
      { keyCode: 40 }
      // Arrow Down
    ],
    moveLeft: [
      { keyCode: 37 }
      // Arrow Left
    ],
    moveRight: [
      { keyCode: 39 }
      // Arrow Right
    ],
    moveUpSome: [
      { keyCode: 38, modKeys: ["shiftKey"] }
      // Arrow Up
    ],
    moveDownSome: [
      { keyCode: 40, modKeys: ["shiftKey"] }
      // Arrow Down
    ],
    moveLeftSome: [
      { keyCode: 37, modKeys: ["shiftKey"] }
      // Arrow Left
    ],
    moveRightSome: [
      { keyCode: 39, modKeys: ["shiftKey"] }
      // Arrow Right
    ],
    moveUpSnapBottomLeft: [
      { keyCode: 38, modKeys: ["shiftKey", "ctrlKey"] }
      // Arrow Up
    ],
    moveDownSnapBottomLeft: [
      { keyCode: 40, modKeys: ["shiftKey", "ctrlKey"] }
      // Arrow Down
    ],
    moveLeftSnapBottomLeft: [
      { keyCode: 37, modKeys: ["shiftKey", "ctrlKey"] }
      // Arrow Left
    ],
    moveRightSnapBottomLeft: [
      { keyCode: 39, modKeys: ["shiftKey", "ctrlKey"] }
      // Arrow Right
    ],
    moveUpSnapTopLeft: [
      { keyCode: 38, modKeys: ["shiftKey", "ctrlKey", "altKey"] }
      // Arrow Up
    ],
    moveDownSnapTopLeft: [
      { keyCode: 40, modKeys: ["shiftKey", "ctrlKey", "altKey"] }
      // Arrow Down
    ],
    moveLeftSnapTopLeft: [
      { keyCode: 37, modKeys: ["shiftKey", "ctrlKey", "altKey"] }
      // Arrow Left
    ],
    moveRightSnapTopLeft: [
      { keyCode: 39, modKeys: ["shiftKey", "ctrlKey", "altKey"] }
      // Arrow Right
    ],
    moveUpSnapTopRight: [
      { keyCode: 38, modKeys: ["shiftKey", "altKey"] }
      // Arrow Up
    ],
    moveDownSnapTopRight: [
      { keyCode: 40, modKeys: ["shiftKey", "altKey"] }
      // Arrow Down
    ],
    moveLeftSnapTopRight: [
      { keyCode: 37, modKeys: ["shiftKey", "altKey"] }
      // Arrow Left
    ],
    moveRightSnapTopRight: [
      { keyCode: 39, modKeys: ["shiftKey", "altKey"] }
      // Arrow Right
    ]
  },
  delete: {
    deleteItem: [
      { keyCode: 8 },
      // Backspace
      { keyCode: 46 }
      // Delete
    ]
  }
};
function Ro(e) {
  var o, i;
  const t = ((o = ee(e.targetTouches)) == null ? void 0 : o.clientX) || e.clientX, n = ((i = ee(e.targetTouches)) == null ? void 0 : i.clientY) || e.clientY;
  return { x: t, y: n };
}
function le(e, t, n) {
  const o = Ro(e);
  return ml(o, t, n);
}
function gl(e) {
  const t = e.x + e.width / 2, n = e.y + e.height / 2;
  return { x: t, y: n };
}
function ml(e, t, n) {
  const o = n.getBoundingClientRect(), i = Math.round((e.x - o.left) / t), r = Math.round((e.y - o.top) / t);
  return { x: i, y: r };
}
function pl(e, t) {
  const n = Math.atan2(t, e), o = n * (180 / Math.PI), i = n > 0 ? 360 - o : o * -1;
  return Math.floor(i);
}
function Ne(e) {
  let t = e;
  return Math.abs(e) > 359 && (t = e % 360), t < 0 && (t += 360), Math.abs(t);
}
function So(e) {
  const t = e.x, n = e.y, o = e.height / 2, i = e.width / 2, r = t + i, a = n + o, l = Math.sqrt(i ** 2 + o ** 2), d = (e.rotation || 0) * (Math.PI / 180), f = o / l, b = Math.asin(f), w = (90 / 180 * Math.PI - b) * 2, S = b * 2, R = (b + d) * -1, L = R - w, T = R - w - S, E = R - w * 2 - S;
  return [
    R,
    L,
    T,
    E
  ].reduce((y, p, u) => {
    const s = y, g = Math.sin(p) * l, h = Math.cos(p) * l, m = {
      x: Math.round(h + r),
      y: Math.round(a - g)
    };
    return s.corners.push(m), (s.left === void 0 || m.x < s.left) && (s.left = m.x), (s.right === void 0 || m.x > s.right) && (s.right = m.x), (s.top === void 0 || m.y < s.top) && (s.top = m.y), (s.bottom === void 0 || m.y > s.bottom) && (s.bottom = m.y), u === 3 && (s.width = s.right - s.left, s.height = s.bottom - s.top), s;
  }, { corners: [] });
}
function Eo(e) {
  const t = e.map(So), n = ds(t.map((i) => i.corners));
  return n.reduce((i, r, a) => ((i.left === void 0 || r.x < i.left) && (i.left = r.x), (i.top === void 0 || r.y < i.top) && (i.top = r.y), (i.right === void 0 || r.x > i.right) && (i.right = r.x), (i.bottom === void 0 || r.y > i.bottom) && (i.bottom = r.y), a === n.length - 1 && (i.width = i.right - i.left, i.height = i.bottom - i.top, i.centerLeft = i.left + i.width / 2, i.centerTop = i.top + i.height / 2), i), {});
}
function Qt(e, t) {
  const n = e.left >= t.left && e.left <= t.right, o = e.top >= t.top && e.top <= t.bottom, i = e.right <= t.right && e.right >= t.left, r = e.bottom <= t.bottom && e.bottom >= t.top, a = e.top < t.top, l = e.bottom > t.bottom, d = e.right > t.right, f = e.left < t.left;
  return n && o || o && i || i && r || r && n || n && i && a && l || o && r && f && d || o && f && d && l || i && l && f && a || r && f && a && d || n && a && d && l || a && d && l && f;
}
function en(e) {
  var r, a, l, d;
  const t = ((r = e.props.maxSize) == null ? void 0 : r.width) || 1 / 0, n = ((a = e.props.maxSize) == null ? void 0 : a.height) || 1 / 0, o = ((l = e.props.minSize) == null ? void 0 : l.width) || Je.width, i = ((d = e.props.minSize) == null ? void 0 : d.height) || Je.height;
  return {
    minWidth: o,
    maxWidth: t,
    minHeight: i,
    maxHeight: n
  };
}
function Io(e) {
  const t = e, {
    minWidth: n,
    maxWidth: o,
    minHeight: i,
    maxHeight: r
  } = en(t);
  return t.width < n && (t.width = n), t.width > o && (t.width = o), t.height < i && (t.height = i), t.height > r && (t.height = r), t;
}
function Kt({ props: e, layout: t, gridItem: n }) {
  const o = e.allowMove && n.props.allowMove, i = e.allowMoveZ && n.props.allowMoveZ, r = e.allowResize && (n.props.allowResizeX || n.props.allowResizeY), a = c(t.allowRotate) && n.props.allowRotate, l = e.allowDelete && n.props.allowDelete;
  return o || r || a || i || l;
}
function je(e) {
  return {
    id: e.id,
    x: e.x || 0,
    y: e.y || 0,
    z: e.z || 0,
    rotation: e.rotation || 0,
    width: e.width || Je.width,
    height: e.height || Je.height,
    data: e.data
  };
}
function q(e) {
  return e.map(je);
}
function fe(e) {
  const t = Math.round(e);
  return t === 0 ? 0 : t;
}
function Z(e) {
  const t = {
    left: e.x,
    top: e.y,
    right: e.x + e.width - 1,
    bottom: e.y + e.height - 1,
    width: e.width,
    height: e.height
  };
  return t.centerLeft = t.left + t.width / 2, t.centerTop = t.top + t.height / 2, t;
}
function Po(e) {
  const n = e.map(Z).reduce((o, i) => {
    const r = o;
    return (r.left === void 0 || i.left < r.left) && (r.left = i.left), (r.right === void 0 || i.right > r.right) && (r.right = i.right), (r.bottom === void 0 || i.bottom > r.bottom) && (r.bottom = i.bottom), (r.top === void 0 || i.top < r.top) && (r.top = i.top), r;
  }, {});
  return n.width = n.right - n.left + 1, n.height = n.bottom - n.top + 1, n.centerLeft = n.left + n.width / 2, n.centerTop = n.top + n.height / 2, n;
}
function Ce({
  boundingBox: e,
  gridItems: t,
  ignoreIds: n = /* @__PURE__ */ new Set()
}) {
  return t.filter((o) => {
    if (!n.has(o.id)) {
      const i = Z(o);
      return Qt(e, i);
    }
    return !1;
  });
}
function vl(e, t) {
  const n = Math.max(e.left, t.left), o = Math.min(e.right, t.right), i = Math.max(e.top, t.top), r = Math.min(e.bottom, t.bottom), a = o - n, l = r - i;
  return a * l;
}
function yl(e, t) {
  const n = e.centerTop - t.centerTop;
  return Math.abs(n);
}
function Hn({
  boundingBox: e,
  gridItems: t
}) {
  return t.map((n) => {
    const o = Z(n);
    return {
      overlapArea: vl(e, o),
      centerDistance: yl(e, o),
      gridItem: n
    };
  });
}
function Qe(e, t, n = /* @__PURE__ */ new Set()) {
  const o = Z(e);
  e.id && n.add(e.id);
  const i = me(Ce({
    boundingBox: o,
    gridItems: t,
    ignoreIds: n
  }), ["y", "x"]);
  if (i.length) {
    const r = ee(i).y, a = o.bottom + 1 - r;
    i.forEach((f) => {
      const b = f;
      b.y += a, n.add(f.id);
    });
    const l = Po(i), d = {
      x: l.left,
      y: l.top,
      width: l.width,
      height: l.height
    };
    Qe(d, t, n);
  }
}
function xl(e, t) {
  let n = !1;
  const o = Z(e);
  for (let i = 0; i < t.length; i += 1) {
    const r = t[i];
    if (r.id !== e.id) {
      const a = Z(r);
      if (Qt(o, a)) {
        n = !0;
        break;
      }
    }
  }
  return n;
}
function et(e) {
  const t = me(e, ["y", "x"]);
  for (let n = 0; n < t.length; n += 1) {
    const o = t[n], i = () => ({
      ...o,
      y: o.y - 1
    });
    let r = i();
    for (; r.y >= 0 && !xl(r, e); )
      o.y = r.y, r = i();
  }
}
function Lo(e) {
  const t = (e.columns || 1) - 1, n = e.autoSize ? 1 / 0 : e.rows - 1;
  return {
    maxRight: t,
    maxBottom: n,
    minLeft: 0,
    minTop: 0
  };
}
function tn({
  gridItem: e,
  props: t
}) {
  const n = Z(e), o = Lo(t);
  return n.left < 0 || n.top < 0 || n.right > o.maxRight || n.bottom > o.maxBottom;
}
function jt({ gridItem: e, props: t }) {
  if (tn({ gridItem: e, props: t })) {
    const o = e, i = Z(e), r = Lo(t);
    e.x < r.minLeft && (o.x = r.minLeft), e.y < r.minTop && (o.y = r.minTop), i.right > r.maxRight && (o.x -= i.right - r.maxRight), i.bottom > r.maxBottom && (o.y -= i.bottom - r.maxBottom);
  }
}
const wl = ["altKey", "shiftKey", "metaKey", "ctrlKey"];
function K(e, t) {
  return e.some((n) => {
    const o = n.isExclusive === void 0 ? !0 : !!n.isExclusive, i = n.modKeys || [], r = ie(n.keyCode), a = !!i.length, l = r && n.keyCode === t.keyCode, d = a && i.every((b) => t[b]);
    let f = !0;
    return o && (f = wl.filter((x) => !i.includes(x)).every((x) => !t[x])), l && d && f || l && !a && f || d && !r && f;
  });
}
function yt({
  itemsOrderedByZ: e,
  zPosition: t,
  zProperty: n = "z"
}) {
  return e.filter((o) => pt(o, n) === t).length;
}
function bl({
  itemsOrderedByZ: e,
  currentZPosition: t,
  zProperty: n = "z"
}) {
  const o = pt(Dt(e), n, 0);
  return ie(t) && t === o && yt({
    itemsOrderedByZ: e,
    zPosition: o
  }) === 1 ? o : o + 1;
}
function Tl({
  itemsOrderedByZ: e,
  currentZPosition: t,
  zProperty: n = "z"
}) {
  const o = pt(ee(e), n, 1);
  return ie(t) && t === o && yt({
    itemsOrderedByZ: e,
    zPosition: o
  }) === 1 ? o : o - 1;
}
function Ml({
  itemsSortedByZ: e,
  currentZPosition: t,
  numPositions: n = 1
}) {
  const o = (x) => {
    const w = [x], S = n - 1;
    for (let R = 0; R < S; R += 1)
      w.push(x + (R + 1));
    return w;
  }, i = Dn(
    e,
    (x) => x.z > t
  );
  if (i === -1) {
    const w = yt({
      itemsOrderedByZ: e,
      zPosition: t
    }) === 1 ? t : t + 1;
    return o(w);
  }
  const r = e[i].z, a = Dn(
    e,
    (x) => x.z > r
  );
  if (a === -1) {
    const x = r + 1;
    return o(x);
  }
  const f = (e[a].z - r) / (n + 1), b = [];
  for (let x = 0; x < n; x += 1) {
    const w = r + (x + 1) * f;
    b.push(w);
  }
  return b;
}
function _l({
  itemsSortedByZ: e,
  currentZPosition: t,
  numPositions: n = 1
}) {
  const o = (x) => {
    const w = [x], S = n - 1;
    for (let R = 0; R < S; R += 1)
      w.push(x - (R + 1));
    return w;
  }, i = Un(
    e,
    (x) => x.z < t
  );
  if (i === -1) {
    const w = yt({
      itemsOrderedByZ: e,
      zPosition: t
    }) === 1 ? t : t - 1;
    return o(w);
  }
  const r = e[i].z, a = Un(
    e,
    (x) => x.z < r
  );
  if (a === -1) {
    const x = r - 1;
    return o(x);
  }
  const l = e[a], f = (r - l.z) / (n + 1), b = [];
  for (let x = 0; x < n; x += 1) {
    const w = r - (x + 1) * f;
    b.push(w);
  }
  return b;
}
function Rl(e, t) {
  const n = Ro(e), o = t.getBoundingClientRect(), i = {
    left: o.left,
    top: o.top,
    right: o.left + t.clientWidth,
    bottom: o.top + t.clientHeight
  };
  return n.x > i.left && n.x < i.right && n.y > i.top && n.y < i.bottom;
}
const Sl = ["data-grid-item-before-id"], El = ["id", "data-grid-item-id"], Il = ["data-grid-item-after-id"], hu = /* @__PURE__ */ Object.assign({
  name: "GridItem",
  inheritAttrs: !1
}, {
  __name: "GridItem",
  props: {
    elementId: {
      type: String,
      default: null
    },
    context: {
      type: Object,
      required: !0
    },
    id: {
      type: String,
      required: !0
    },
    x: {
      type: Number,
      required: !0
    },
    y: {
      type: Number,
      required: !0
    },
    z: {
      type: Number,
      default: 1
    },
    width: {
      type: Number,
      required: !0
    },
    height: {
      type: Number,
      required: !0
    },
    rotation: {
      type: Number,
      default: 0
    },
    minSize: {
      type: Object,
      default: () => xe(Je)
    },
    maxSize: {
      type: Object,
      default: () => ({ width: 1 / 0, height: 1 / 0 })
    },
    allowMove: {
      type: Boolean,
      default: !0
    },
    allowMoveZ: {
      type: Boolean,
      default: !0
    },
    allowResizeX: {
      type: Boolean,
      default: !0
    },
    allowResizeY: {
      type: Boolean,
      default: !0
    },
    allowRotate: {
      type: Boolean,
      default: !0
    },
    allowDelete: {
      type: Boolean,
      default: !0
    },
    allowAnimation: {
      type: Boolean,
      default: !0
    }
  },
  setup(e) {
    const t = G(null), n = e;
    n.context.layout.registerGridItemProps(n.id, n), ne(() => {
      n.context.layout.unregisterGridItemProps(n.id);
    });
    const o = A(() => n.context.layout.getItemById(n.id));
    ["minSize", "maxSize"].forEach((E) => {
      k(() => n[E], (v, y) => {
        Yc(v, y) || Io(c(o));
      });
    });
    const r = A(() => {
      const E = c(o), v = c(n.context.layout.itemZLookup);
      let y = {
        x: n.x,
        y: n.y,
        width: n.width,
        height: n.height
      };
      c(n.context.layout.isUnitsTypePixels) || (y = n.context.layout.unitsToPixels(y), E.moveData && (y.x = E.moveData.xPixels, y.y = E.moveData.yPixels), E.resizeData && (y.width = E.resizeData.widthPixels, y.height = E.resizeData.heightPixels));
      const p = c(b) ? 2147483644 : v[E.id] || 1;
      return {
        top: `${y.y}px`,
        left: `${y.x}px`,
        width: `${y.width}px`,
        height: `${y.height}px`,
        zIndex: p,
        transform: `rotate(${n.rotation}deg)`
      };
    }), a = A(() => n.context.selection.isSelected(n.id)), l = A(() => {
      const E = n.context.props.allowMove && n.allowMove, v = c(n.context.move.hasMoved);
      return c(a) && v && E;
    }), d = A(() => {
      const E = n.context.props.allowResize && (n.allowResizeX || n.allowResizeY), v = c(n.context.resize.hasResized);
      return c(a) && v && E;
    }), f = A(() => {
      const E = c(n.context.layout.isUnitsTypePixels);
      return n.context.props.showPlaceholder && !E;
    }), b = A(() => (c(l) || c(d)) && c(f)), x = A(
      () => Kt({
        props: n.context.props,
        layout: n.context.layout,
        gridItem: c(o)
      })
    ), w = A(
      () => c(n.context.selection.canSelect)
    ), S = A(() => n.context.props.allowMove ? c(a) ? c(n.context.selection.selectedGridItems).every((E) => E.props.allowMove) : n.allowMove : !1), R = A(
      () => !c(n.context.layout.isUnitsTypePixels) && !c(a) && n.context.props.allowAnimation && n.allowAnimation
    ), L = (E) => {
      const v = c(o), y = c(n.context.layout.keyCommands), p = K(
        y.selection.multipleSelect,
        E
      );
      n.context.selection.selectGridItem(v, p), n.context.move.onMoveStart(E, v), n.context.layout.emit("item-mousedown", {
        event: E,
        itemElement: c(t),
        item: v
      });
    }, T = () => {
      n.context.selection.isSelected(n.id) || n.context.selection.clearSelection();
    };
    return (E, v) => (W(), he(zo, null, [
      re("div", {
        "data-grid-item-before-id": n.id,
        class: "titan-grid-item-before",
        onMousedown: v[0] || (v[0] = Ge((y) => w.value ? T() : void 0, ["left"]))
      }, [
        Fe(E.$slots, "before")
      ], 40, Sl),
      re("div", {
        ref_key: "itemRef",
        ref: t,
        class: Be(["titan-grid-item", [
          {
            "titan-grid-item--is-selected": a.value,
            "titan-grid-item--allow-move": S.value,
            "titan-grid-item--is-transparent": b.value,
            "titan-grid-item--is-animated": R.value
          },
          E.$attrs.class
        ]]),
        id: n.elementId || n.id,
        "data-grid-item-id": n.id,
        style: ze(r.value),
        onMousedown: v[1] || (v[1] = Ge((y) => x.value ? L(y) : void 0, ["left"])),
        onTouchstart: v[2] || (v[2] = (y) => x.value ? L(y) : void 0)
      }, [
        Fe(E.$slots, "default")
      ], 46, El),
      re("div", {
        "data-grid-item-after-id": n.id,
        class: "titan-grid-item-after",
        onMousedown: v[3] || (v[3] = Ge((y) => w.value ? T() : void 0, ["left"]))
      }, [
        Fe(E.$slots, "after")
      ], 40, Il)
    ], 64));
  }
}), F = [];
for (let e = 0; e < 256; ++e)
  F.push((e + 256).toString(16).slice(1));
function Pl(e, t = 0) {
  return (F[e[t + 0]] + F[e[t + 1]] + F[e[t + 2]] + F[e[t + 3]] + "-" + F[e[t + 4]] + F[e[t + 5]] + "-" + F[e[t + 6]] + F[e[t + 7]] + "-" + F[e[t + 8]] + F[e[t + 9]] + "-" + F[e[t + 10]] + F[e[t + 11]] + F[e[t + 12]] + F[e[t + 13]] + F[e[t + 14]] + F[e[t + 15]]).toLowerCase();
}
let Et;
const Ll = new Uint8Array(16);
function Ol() {
  if (!Et) {
    if (typeof crypto > "u" || !crypto.getRandomValues)
      throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
    Et = crypto.getRandomValues.bind(crypto);
  }
  return Et(Ll);
}
const Cl = typeof crypto < "u" && crypto.randomUUID && crypto.randomUUID.bind(crypto), Nn = { randomUUID: Cl };
function Al(e, t, n) {
  var i;
  if (Nn.randomUUID && !e)
    return Nn.randomUUID();
  e = e || {};
  const o = e.random ?? ((i = e.rng) == null ? void 0 : i.call(e)) ?? Ol();
  if (o.length < 16)
    throw new Error("Random bytes length must be >= 16");
  return o[6] = o[6] & 15 | 64, o[8] = o[8] & 63 | 128, Pl(o);
}
function $l({
  props: e,
  gridLayoutRef: t,
  snapGrid: n,
  emit: o,
  context: i
}) {
  const r = G(0);
  let a;
  const l = G({}), d = G([]), f = /* @__PURE__ */ new Map(), b = Al(), x = (P, I) => {
    const z = c(l)[P];
    z && (z.props = I), f.set(P, I);
  }, w = (P) => {
    f.delete(P);
  }, S = () => {
    const P = c(d);
    P.forEach((I) => {
      Io(I), e.allowOutOfBounds || jt({ gridItem: I, props: e });
    }), e.allowOverlap || me(P, ["y", "x"]).forEach((z) => {
      const B = /* @__PURE__ */ new Set([z.id]);
      Qe(
        z,
        P,
        B
      );
    }), e.compact && et(P);
  }, R = () => {
    const P = To(q(e.items), (z) => {
      const B = Wn(z), U = f.get(B.id);
      return U && (B.props = U), B;
    }), I = el(P, (z, B) => (z[B.id] = B, z), {});
    d.value = P, l.value = I, It(S);
  };
  k(() => e.items, () => {
    R();
  }), k(() => e.unitsType, () => {
    c(T) ? u() : p();
  });
  const L = (P) => c(l)[P], T = A(
    () => e.unitsType === We
  ), E = A(() => e.allowRotate && c(T)), v = () => {
    r.value = c(t).clientWidth;
  }, y = we(v, 10), p = () => {
    u();
    const P = c(t);
    P && !c(T) && (a = new ResizeObserver(y), a.observe(P), v());
  }, u = () => {
    a && (a.disconnect(), a = null);
  }, s = A(() => me(c(d), "z")), g = A(() => c(s).reduce((I, z, B) => (I[z.id] = B + 1, I), {})), h = A(() => {
    var P;
    return ((P = e.margin) == null ? void 0 : P.y) || 0;
  }), m = A(() => {
    var P;
    return ((P = e.margin) == null ? void 0 : P.x) || 0;
  }), M = A(() => {
    let P = e.rows;
    return e.autoSize && (P = c(d).reduce((z, B) => {
      var V, de;
      let U = B.y + B.height;
      const Y = c((de = (V = c(i)) == null ? void 0 : V.placeholder) == null ? void 0 : de.box);
      if (Y) {
        const Se = (Y.y || 0) + (Y.height || 0);
        Se > U && (U = Se);
      }
      return U > z ? U : z;
    }, P)), (P + 1) * c(h) + P * e.rowHeight;
  }), _ = () => {
    o("height-changed", { height: c(M) });
  };
  k(M, _);
  const O = A(() => {
    if (!e.columns) return 1;
    const P = c(r) - c(m);
    return Math.round(P / e.columns) - c(m);
  }), C = A(() => {
    const P = (z, B) => X(B) ? B : void 0;
    return Wc(
      xe(hl),
      e.keyCommands,
      P
    );
  }), $ = (P) => {
    const I = { ...P }, z = c(O), B = c(m), U = c(h);
    return ie(I.x) && (I.x = fe(B * (I.x + 1) + I.x * z)), ie(I.y) && (I.y = fe(U * (I.y + 1) + I.y * e.rowHeight)), ie(I.width) && (I.width = fe((I.width - 1) * B + I.width * z)), ie(I.height) && (I.height = fe((I.height - 1) * U + I.height * e.rowHeight)), I;
  }, D = (P) => {
    const I = { ...P }, z = c(O), B = c(m), U = c(h);
    return ie(I.x) && (I.x = fe((I.x - B) / (z + B))), ie(I.y) && (I.y = fe((I.y - U) / (e.rowHeight + U))), ie(I.width) && (I.width = fe((I.width + B) / (z + B))), ie(I.height) && (I.height = fe((I.height + U) / (e.rowHeight + U))), I;
  }, j = () => {
    o("layout-changed", {
      items: q(c(d))
    });
  };
  return De(() => {
    p(), R(), It(_);
  }), ne(() => {
    u();
  }), {
    allowRotate: E,
    getItemById: L,
    gridLayoutRef: t,
    id: b,
    items: d,
    itemsById: l,
    itemsSortedByZ: s,
    itemZLookup: g,
    keyCommands: C,
    layoutWidthPixels: r,
    layoutHeightPixels: M,
    props: e,
    registerGridItemProps: x,
    snapGrid: n,
    unregisterGridItemProps: w,
    unitsToPixels: $,
    isUnitsTypePixels: T,
    onLayoutUpdated: j,
    pixelsToUnits: D,
    emit: o
  };
}
function zl({
  props: e,
  layout: t,
  emit: n
}) {
  const o = Wn(/* @__PURE__ */ new Set()), i = A(() => {
    const s = Array.from(o.keys()).map((g) => c(t.itemsById)[g]).filter((g) => g);
    return me(s, ["y", "x"]);
  }), r = A(() => ee(c(i))), a = (s) => o.has(s.id), l = (s, g = !1) => {
    if (!Kt({ props: e, layout: t, gridItem: s })) return;
    const h = e.allowMultiselect && g;
    if (!(!h && o.has(s.id))) {
      if (h && o.has(s.id)) {
        o.delete(s.id);
        return;
      }
      h || f(), o.add(s.id);
    }
  }, d = (s) => o.has(s), f = (s) => {
    s ? s.forEach((g) => o.delete(g)) : o.clear();
  }, b = (s, g = !1) => {
    g || f(), (e.allowMultiselect ? s : s.slice(0, 1)).filter((m) => Kt({ props: e, layout: t, gridItem: m })).forEach((m) => {
      o.add(m.id);
    });
  }, x = (s, g = !1) => {
    const h = c(t.itemsById), m = s.map((M) => h[M]);
    b(m, g);
  }, w = A(() => {
    const s = c(i).map((h) => `[${rl}="${h.id}"]`);
    let g = Ut;
    return s != null && s.length && (g += `,${s.join(",")}`), g;
  }), S = (s) => {
    if (!(!Mo(s.button) && s.button !== 0)) {
      if (e.allowMultiselect) {
        const h = c(t.keyCommands).selection, { multipleSelect: m } = h;
        if (K(m, s))
          return;
      }
      s.target.closest(c(w)) || f();
    }
  }, R = (s) => {
    if (!c(L)) return;
    let g = Ut;
    e.allowSelectionBox && (g += `,${e.selectionContainer}`), !!s.target.closest(g) && s.ctrlKey && s.preventDefault();
  }, L = A(
    () => e.allowMove || e.allowResize || c(t.allowRotate) || e.allowDelete || e.allowMoveZ
  ), T = A(() => {
    const s = c(i);
    return e.allowResize && s.every((g) => g.props.allowResizeX);
  }), E = A(() => {
    const s = c(i);
    return e.allowResize && s.every((g) => g.props.allowResizeY);
  }), v = A(() => c(T) || c(E)), y = () => {
    p(), document.addEventListener("mousedown", S), document.addEventListener("contextmenu", R);
  }, p = () => {
    document.removeEventListener("mousedown", S), document.removeEventListener("contextmenu", R);
  }, u = () => {
    Array.from(o.keys()).filter((s) => !c(t.itemsById)[s]).forEach((s) => {
      o.delete(s);
    });
  };
  return k(t.items, u), k(L, (s) => {
    s ? y() : p();
  }), k(o, () => {
    n("selection-changed", {
      items: q(c(i))
    });
  }), De(() => {
    c(L) && y();
  }), ne(() => {
    p();
  }), {
    allowResize: v,
    allowResizeX: T,
    allowResizeY: E,
    canSelect: L,
    isSelected: d,
    selectedIds: o,
    selectedGridItems: i,
    gridItemIsSelected: a,
    selectGridItem: l,
    selectGridItems: b,
    selectGridItemIds: x,
    clearSelection: f,
    firstSelectedItem: r
  };
}
function Bl({
  props: e,
  layout: t,
  selection: n,
  boundingBox: o,
  snapGrid: i,
  emit: r
}) {
  let a = null;
  const l = G(!1), d = G(!1), f = we((u) => {
    r("move-change", u);
  }, Ke), b = ({
    gridItems: u,
    moveX: s,
    moveY: g
  }) => {
    const h = [];
    return u.forEach((m) => {
      const M = t.getItemById(m.id);
      M && (M.x = m.x + s, M.y = m.y + g, h.push(M));
    }), h;
  }, x = (u, s) => {
    if (c(l) || !e.allowMove || !n.isSelected(s.id) || c(n.selectedGridItems).some((_) => !_.props.allowMove) || u.target.closest(e.moveIgnore)) {
      l.value = !1;
      return;
    }
    u.preventDefault(), T();
    const { x: g, y: h } = le(
      u,
      e.scale,
      c(t.gridLayoutRef)
    ), m = q(c(n.selectedGridItems)), M = xe(c(o == null ? void 0 : o.box));
    a = {
      startX: g,
      startY: h,
      gridItems: m,
      boundingBox: M
    }, l.value = !0, r("move-start", a);
  }, w = (u) => {
    if (!c(l))
      return;
    u.preventDefault();
    const { x: s, y: g } = le(
      u,
      e.scale,
      c(t.gridLayoutRef)
    ), { startX: h, startY: m } = a;
    let M = s - h, _ = g - m;
    const O = c(t.keyCommands);
    if (c(i.grid)) {
      const D = K(
        O.move.snapGrid.snapToLeft,
        u
      ) ? "left" : "right", j = a.boundingBox[D], I = K(
        O.move.snapGrid.snapToTop,
        u
      ) ? "top" : "bottom", z = a.boundingBox[I], B = j + M, U = z + _, Y = i.getSnapPoint({
        [D]: B,
        [I]: U
      });
      M = Y[D] - j, _ = Y[I] - z;
    } else K(O.move.moveXOnly, u) ? _ = 0 : K(O.move.moveYOnly, u) && (M = 0);
    const C = b({
      gridItems: a.gridItems,
      moveX: M,
      moveY: _
    });
    d.value = !0, f({
      items: q(C),
      startY: m,
      startX: h,
      moveY: _,
      moveX: M
    });
  }, S = (u) => {
    var h;
    if (!c(l) || ((h = u == null ? void 0 : u.touches) == null ? void 0 : h.length) > 0) return;
    const s = [];
    c(d) && a.gridItems.forEach((m) => {
      const M = t.getItemById(m.id);
      M && (M.x !== m.x || M.y !== m.y) && s.push(je(M));
    });
    const g = !!(s != null && s.length);
    l.value = !1, d.value = !1, E(), r("move-end", {
      items: s
    }), g && t.onLayoutUpdated();
  }, R = we(t.onLayoutUpdated, 500), L = (u) => {
    if (!e.allowMove || u.target.closest(e.moveIgnore)) return;
    const s = c(n.selectedGridItems);
    if (!s.length || !s.every((rn) => {
      var ge;
      return (ge = rn.props) == null ? void 0 : ge.allowMove;
    })) return;
    const h = c(t.keyCommands).move, m = K(h.moveUp, u), M = K(h.moveDown, u), _ = K(h.moveLeft, u), O = K(h.moveRight, u), C = K(h.moveUpSome, u), $ = K(h.moveDownSome, u), D = K(h.moveLeftSome, u), j = K(h.moveRightSome, u), P = K(h.moveUpSnapBottomLeft, u), I = K(h.moveDownSnapBottomLeft, u), z = K(h.moveLeftSnapBottomLeft, u), B = K(h.moveRightSnapBottomLeft, u), U = K(h.moveUpSnapTopLeft, u), Y = K(h.moveDownSnapTopLeft, u), V = K(h.moveLeftSnapTopLeft, u), de = K(h.moveRightSnapTopLeft, u), Se = K(h.moveUpSnapTopRight, u), xt = K(h.moveDownSnapTopRight, u), wt = K(h.moveLeftSnapTopRight, u), bt = K(h.moveRightSnapTopRight, u), Ee = c(i.grid), nn = m || M || _ || O, Co = (nn || (C || $ || D || j)) && !Ee, on = (nn || U || Y || V || de || Se || xt || wt || bt || P || I || z || B) && !!Ee;
    if (!Co && !on) return;
    u.preventDefault();
    let Ie = 0, Pe = 0;
    if (on) {
      const ge = U || Y || V || de || Se || xt || wt || bt ? "top" : "bottom", Le = P || I || z || B || U || Y || V || de ? "left" : "right", Tt = c(o == null ? void 0 : o.box), Oe = xe(Tt);
      (m || U || Se || P) && (Oe[ge] -= Ee.cellHeight), (M || Y || xt || I) && (Oe[ge] += Ee.cellHeight), (_ || V || wt || z) && (Oe[Le] -= Ee.cellWidth), (O || de || bt || B) && (Oe[Le] += Ee.cellWidth);
      const Ao = Oe[Le], $o = Oe[ge], sn = i.getSnapPoint({
        [Le]: Ao,
        [ge]: $o
      });
      Ie = Math.round(sn[Le] - Tt[Le]), Pe = Math.round(sn[ge] - Tt[ge]);
    } else C ? Pe = it * -1 : $ ? Pe = it : D ? Ie = it * -1 : j ? Ie = it : m ? Pe = -1 : M ? Pe = 1 : _ ? Ie = -1 : O && (Ie = 1);
    b({
      gridItems: s,
      moveX: Ie,
      moveY: Pe
    }), R();
  }, T = () => {
    const u = { passive: !1 };
    document.addEventListener("mousemove", w), document.addEventListener("mouseup", S), document.addEventListener("touchmove", w, u), document.addEventListener("touchend", S);
  }, E = () => {
    document.removeEventListener("mousemove", w), document.removeEventListener("mouseup", S), document.removeEventListener("touchmove", w), document.removeEventListener("touchend", S);
  }, v = () => {
    document.addEventListener("keydown", L);
  }, y = () => {
    document.removeEventListener("keydown", L);
  }, p = () => {
    y();
  };
  return ne(() => {
    E();
  }), v(), {
    onDestroy: p,
    isMoving: l,
    hasMoved: d,
    onMoveStart: x
  };
}
function Dl({
  props: e,
  layout: t,
  selection: n,
  boundingBox: o,
  emit: i
}) {
  let r = null;
  const a = G(!1), l = G(!1);
  let d;
  const f = we((p) => {
    i("move-change", p);
  }, Ke), b = () => {
    r.gridItems.forEach((p) => {
      const u = t.getItemById(p.id);
      u && delete u.moveData;
    });
  }, x = ({ xMove: p, yMove: u }) => {
    const s = t.unitsToPixels(r.placeholderBox);
    return p && (s.x += p), u && (s.y += u), t.pixelsToUnits(s);
  }, w = (p) => {
    const u = tn({
      gridItem: p,
      props: e
    });
    !e.allowOutOfBounds && u && jt({
      gridItem: p,
      props: e
    });
  }, S = ({
    gridItems: p,
    moveX: u,
    moveY: s,
    inPixels: g = !1
  }) => {
    const h = [];
    return p.forEach((m) => {
      const M = t.getItemById(m.id);
      if (M) {
        if (g) {
          const _ = t.unitsToPixels(xe(m)), O = _.x + u, C = _.y + s;
          M.moveData = {
            xPixels: fe(O),
            yPixels: fe(C)
          };
        } else
          M.x += u, M.y += s;
        h.push(M);
      }
    }), h;
  }, R = (p, u) => {
    if (c(a) || !e.allowMove || !n.isSelected(u.id) || c(n.selectedGridItems).some((_) => !_.props.allowMove) || p.target.closest(e.moveIgnore)) {
      a.value = !1;
      return;
    }
    p.preventDefault(), v();
    const { x: s, y: g } = le(
      p,
      e.scale,
      c(t.gridLayoutRef)
    ), h = q(c(n.selectedGridItems)), m = xe(c(o == null ? void 0 : o.box)), M = t.pixelsToUnits({
      x: m.left,
      y: m.top,
      width: m.width,
      height: m.height
    });
    d = M, r = {
      startX: s,
      startY: g,
      gridItems: h,
      boundingBox: m,
      placeholderBox: M
    }, a.value = !0, i("move-start", r);
  }, L = (p) => {
    if (!c(a))
      return;
    p.preventDefault();
    const { x: u, y: s } = le(
      p,
      e.scale,
      c(t.gridLayoutRef)
    ), { startX: g, startY: h } = r, m = u - g, M = s - h;
    let _ = x({ xMove: m, yMove: M });
    if (!e.allowOverlap && !e.moveOnCollision) {
      const D = [
        { xMove: m, yMove: M },
        { yMove: M },
        { xMove: m }
      ];
      let j = !1;
      for (let P = 0; P < D.length; P += 1) {
        const I = D[P], z = x(I);
        I.xMove || (z.x = d.x), I.yMove || (z.y = d.y), w(z);
        const B = Z(z), U = new Set(r.gridItems.map((V) => V.id));
        if (!Ce({
          boundingBox: B,
          gridItems: c(t.items),
          ignoreIds: U
        }).length) {
          _ = z, j = !0;
          break;
        }
      }
      j || (_ = d);
    }
    if (!e.allowOverlap && e.moveOnCollision) {
      const D = Z(_), j = new Set(r.gridItems.map((I) => I.id)), P = Ce({
        boundingBox: D,
        gridItems: c(t.items),
        ignoreIds: j
      });
      if (P.length) {
        const I = Hn({
          boundingBox: D,
          gridItems: P
        }), z = ee(me(
          I,
          ["overlapArea", "centerDistance"]
        )).gridItem, B = Z(z);
        D.centerTop > B.centerTop ? _.y = B.bottom + 1 : _.y = B.top, w(_), Qe(
          _,
          c(t.items),
          j
        );
      }
    }
    w(_), d = _;
    const O = _.x - r.placeholderBox.x, C = _.y - r.placeholderBox.y;
    r.gridItems.forEach((D) => {
      const j = c(t.itemsById)[D.id];
      j && (j.x = D.x + O, j.y = D.y + C);
    }), e.compact && et(c(t.items));
    const $ = S({
      gridItems: r.gridItems,
      moveX: m,
      moveY: M,
      inPixels: !0
    });
    l.value = !0, f({
      items: q($),
      startY: h,
      startX: g,
      moveY: M,
      moveX: m
    });
  }, T = (p) => {
    var g;
    if (!c(a) || ((g = p == null ? void 0 : p.touches) == null ? void 0 : g.length) > 0) return;
    const u = [];
    c(l) && (b(), r.gridItems.forEach((h) => {
      const m = t.getItemById(h.id);
      m && (m.x !== h.x || m.y !== h.y) && u.push(je(m));
    }));
    const s = !!(u != null && u.length);
    a.value = !1, l.value = !1, y(), i("move-end", {
      items: u
    }), s && t.onLayoutUpdated();
  }, E = (p, u) => {
    const g = c(t.itemsById)[p];
    if (!g) return;
    const h = {
      x: u.x,
      y: u.y,
      width: g.width,
      height: g.height
    };
    if (!e.allowOverlap) {
      const m = Z(h), M = /* @__PURE__ */ new Set([g.id]), _ = Ce({
        boundingBox: m,
        gridItems: c(t.items),
        ignoreIds: M
      });
      if (_.length) {
        if (!e.moveOnCollision)
          return;
        const O = Hn({
          boundingBox: m,
          gridItems: _
        }), C = ee(me(
          O,
          ["overlapArea", "centerDistance"]
        )).gridItem, $ = Z(C);
        m.top > $.centerTop ? h.y = $.bottom + 1 : h.y = $.top, Qe(
          h,
          c(t.items),
          M
        );
      }
    }
    e.allowOutOfBounds || jt({ gridItem: h, props: e }), g.x = h.x, g.y = h.y, e.compact && et(c(t.items));
  }, v = () => {
    const p = { passive: !1 };
    document.addEventListener("mousemove", L), document.addEventListener("mouseup", T), document.addEventListener("touchmove", L, p), document.addEventListener("touchend", T);
  }, y = () => {
    document.removeEventListener("mousemove", L), document.removeEventListener("mouseup", T), document.removeEventListener("touchmove", L), document.removeEventListener("touchend", T);
  };
  return ne(() => {
    y();
  }), {
    isMoving: a,
    hasMoved: l,
    onMoveStart: R,
    tryMove: E
  };
}
function Ul({
  props: e,
  layout: t,
  boundingBox: n,
  selection: o,
  emit: i
}) {
  const r = G(null), a = G(!1), l = G(null);
  let d, f;
  ne(() => {
    v();
  });
  const b = we((y) => {
    i("rotation-change", y);
  }, Ke), x = A(() => {
    const y = c(o.selectedGridItems);
    return c(t.allowRotate) && y.every((p) => p.props.allowRotate);
  }), w = (y) => {
    const { x: p, y: u } = le(
      y,
      e.scale,
      c(t.gridLayoutRef)
    ), s = c(l).y - u, g = p - c(l).x;
    return pl(g, s);
  }, S = (y) => {
    const p = w(y);
    return p === 0 ? p : p > 180 ? 360 - p : p * -1;
  }, R = (y) => {
    var s;
    E(), y.preventDefault();
    const { centerLeft: p, centerTop: u } = c(n == null ? void 0 : n.box);
    l.value = { x: p, y: u }, f = q(c(o.selectedGridItems)), d = S(y), r.value = (f == null ? void 0 : f.length) > 1 ? 0 : ((s = ee(f)) == null ? void 0 : s.rotation) || 0, a.value = !0, i("rotation-start", {
      rotationDegrees: c(r),
      items: f
    });
  }, L = (y) => {
    var _;
    if (!c(a)) return;
    y.preventDefault();
    const p = w(y);
    let u = Ne(
      p + d
    );
    const s = c(t.keyCommands);
    if (K(s.rotate.snapTo15, y))
      if ((f == null ? void 0 : f.length) > 1) {
        const O = Math.round(u / rt);
        u = rt * O;
      } else {
        const O = ee(f).rotation, C = Ne(360 - u), $ = Ne(O - C), D = Math.round($ / rt);
        u = rt * D - O;
      }
    const h = 360 - u, m = h * (Math.PI / 180), M = [];
    f.forEach((O) => {
      const C = t.getItemById(O.id);
      if (C) {
        C.rotation = Ne(O.rotation + u);
        const $ = c(l).x, D = c(l).y, j = gl(O), P = j.x - $, I = D - j.y, z = Math.sqrt(P ** 2 + I ** 2), U = Math.atan2(I, P) + m, Y = Math.sin(U) * z, V = Math.cos(U) * z;
        C.x = Math.round($ + V - O.width / 2), C.y = Math.round(D - Y - O.height / 2), M.push(C);
      }
    }), r.value = (M == null ? void 0 : M.length) > 1 ? Ne(360 - h) : ((_ = ee(M)) == null ? void 0 : _.rotation) || 0, b({
      rotationDegrees: c(r),
      items: q(M)
    });
  }, T = (y) => {
    var s;
    if (!c(a) || ((s = y == null ? void 0 : y.touches) == null ? void 0 : s.length) > 0) return;
    a.value = !1, v();
    const p = f.filter((g) => {
      const h = t.getItemById(g.id);
      return h ? h.rotation !== g.rotation || h.x !== g.x || h.y !== g.y : !1;
    }), u = !!(p != null && p.length);
    i("rotation-end", {
      rotationDegrees: c(r),
      items: p
    }), u && t.onLayoutUpdated();
  }, E = () => {
    const y = { passive: !1 };
    document.addEventListener("mousemove", L), document.addEventListener("mouseup", T), document.addEventListener("touchmove", L, y), document.addEventListener("touchend", T);
  }, v = () => {
    document.removeEventListener("mousemove", L), document.removeEventListener("mouseup", T), document.removeEventListener("touchmove", L), document.removeEventListener("touchend", T);
  };
  return {
    allowRotate: x,
    isRotating: a,
    rotationDegrees: r,
    rotationCenter: l,
    onRotateStart: R
  };
}
function Kl({
  props: e,
  layout: t,
  boundingBox: n,
  selection: o,
  snapGrid: i,
  emit: r
}) {
  const a = G(!1), l = G(!1), d = G(null);
  let f = null, b = null, x = null;
  ne(() => {
    y();
  });
  const w = we((p) => {
    r("resize-change", p);
  }, Ke), S = (p, u) => {
    let s = c(o.allowResizeX), g = c(o.allowResizeY), h = [];
    return (s || g) && (h = x.map((m) => {
      const M = t.getItemById(m.id);
      if (M) {
        let {
          minWidth: _,
          maxWidth: O,
          minHeight: C,
          maxHeight: $
        } = en(M);
        if (u) {
          const z = O / m.width, B = $ / m.height, U = Math.min(z, B);
          O = Math.round(m.width * U), $ = Math.round(m.height * U);
          const Y = m.width / _, V = m.height / C, de = Math.min(Y, V);
          _ = Math.round(m.width / de), C = Math.round(m.height / de);
        }
        const D = Math.round(p.width * m.widthPct), j = Math.round(p.height * m.heightPct), P = Math.round(p.left + m.leftPct * p.width), I = Math.round(p.top + m.topPct * p.height);
        return (D < _ || D > O) && (s = !1), (j < C || j > $) && (g = !1), {
          gridItem: M,
          width: D,
          height: j,
          x: P,
          y: I
        };
      }
      return null;
    }).filter((m) => m)), {
      changes: h,
      canResizeWidth: s,
      canResizeHeight: g,
      canResize: s || g
    };
  }, R = (p) => {
    const u = [];
    if (!p.canResize)
      return u;
    const { changes: s, canResizeWidth: g, canResizeHeight: h } = p;
    return s.forEach((m) => {
      const M = m, { gridItem: _ } = M;
      g && (_.width = M.width, _.x = M.x), h && (_.height = M.height, _.y = M.y), u.push(_);
    }), u;
  }, L = (p, u = "bottom-right") => {
    v();
    const s = c(n.box);
    b = s, d.value = u, f = le(
      p,
      e.scale,
      c(t.gridLayoutRef)
    ), x = q(c(o.selectedGridItems)).map((h) => {
      const m = (h.x - s.left) / s.width, M = (h.y - s.top) / s.height, _ = h.width / s.width, O = h.height / s.height;
      return {
        leftPct: m,
        topPct: M,
        widthPct: _,
        heightPct: O,
        ...h
      };
    }), p.preventDefault(), a.value = !0, r("resize-start", {
      boundingBox: s,
      position: d,
      items: x
    });
  }, T = (p) => {
    if (!c(a)) return;
    p.preventDefault();
    const u = !!c(i == null ? void 0 : i.grid), s = c(t.keyCommands), g = K(
      s.resize.keepAspectRatio,
      p
    ), h = K(
      s.resize.resizeOnCenter,
      p
    ), m = g && !u, M = h && !u, { x: _, y: O } = le(
      p,
      e.scale,
      c(t.gridLayoutRef)
    ), C = xe(b);
    n.resize({
      boundingBox: C,
      position: d,
      resizeStart: f,
      resizeOnCenter: M,
      preserveAspectRatio: m,
      x: _,
      y: O
    });
    const $ = S(C, m), D = R($);
    l.value = !0, D.length && w({
      boundingBox: C,
      items: q(D)
    });
  }, E = (p) => {
    var u;
    if (c(a) && !(((u = p == null ? void 0 : p.touches) == null ? void 0 : u.length) > 0)) {
      if (c(l)) {
        const s = x.filter((h) => {
          const m = t.getItemById(h.id);
          return m ? m.width !== h.width || m.height !== h.height || m.x !== h.x || m.y !== h.y : !1;
        }), g = !!(s != null && s.length);
        r("resize-end", {
          items: s
        }), g && t.onLayoutUpdated();
      }
      a.value = !1, l.value = !1, y();
    }
  }, v = () => {
    const p = { passive: !1 };
    document.addEventListener("mousemove", T), document.addEventListener("mouseup", E), document.addEventListener("touchmove", T, p), document.addEventListener("touchend", E);
  }, y = () => {
    document.removeEventListener("mousemove", T), document.removeEventListener("mouseup", E), document.removeEventListener("touchmove", T), document.removeEventListener("touchend", E);
  };
  return {
    isResizing: a,
    hasResized: l,
    position: d,
    onResizeStart: L
  };
}
function jl({
  props: e,
  layout: t,
  boundingBox: n,
  selection: o,
  emit: i
}) {
  const r = G(!1), a = G(!1), l = G(null);
  let d = null, f = null, b = null;
  ne(() => {
    u();
  });
  const x = we((s) => {
    i("resize-change", s);
  }, Ke), w = () => {
    b.forEach((s) => {
      const g = t.getItemById(s.id);
      g && (delete g.moveData, delete g.resizeData);
    });
  }, S = (s, { copyItems: g = !1, useUnits: h = !1 } = {}) => {
    let m = c(o.allowResizeX), M = c(o.allowResizeY), _ = [];
    return (m || M) && (_ = b.map((O) => {
      let C = t.getItemById(O.id);
      if (C) {
        const $ = en(C);
        g && (C = je(C));
        const D = t.unitsToPixels({
          width: $.minWidth,
          height: $.minHeight
        }), j = t.unitsToPixels({
          width: $.maxWidth,
          height: $.maxHeight
        }), P = Math.round(s.width * O.widthPct), I = Math.round(s.height * O.heightPct), z = Math.round(s.left + O.leftPct * s.width), B = Math.round(s.top + O.topPct * s.height), U = t.pixelsToUnits({
          x: z,
          y: B,
          width: P,
          height: I
        });
        return h ? ((U.width < $.minWidth || U.width > $.maxWidth) && (m = !1), (U.height < $.minHeight || U.height > $.maxHeight) && (M = !1)) : ((P < D.width || P > j.width) && (m = !1), (I < D.height || I > j.height) && (M = !1)), {
          gridItem: C,
          widthPixels: P,
          heightPixels: I,
          xPixels: z,
          yPixels: B,
          ...U
        };
      }
      return null;
    }).filter((O) => O)), {
      changes: _,
      canResizeWidth: m,
      canResizeHeight: M,
      canResize: m || M
    };
  }, R = (s) => {
    const { changes: g, canResizeWidth: h, canResizeHeight: m } = s;
    g.forEach((M) => {
      const _ = M, { gridItem: O } = _;
      h && (O.width = _.width, O.x = _.x), m && (O.height = _.height, O.y = _.y);
    });
  }, L = (s) => {
    if (!s.canResize)
      return {
        resizedGridItems: []
      };
    const { changes: g, canResizeWidth: h, canResizeHeight: m } = s, M = [];
    return g.forEach((_) => {
      const O = _, { gridItem: C } = O, $ = t.unitsToPixels({
        width: C.width,
        height: C.height,
        x: C.x,
        y: C.y
      });
      if (C.resizeData || (C.resizeData = {
        widthPixels: $.width,
        heightPixels: $.height
      }), C.moveData || (C.moveData = {
        xPixels: $.x,
        yPixels: $.y
      }), h)
        C.resizeData.widthPixels = O.widthPixels, C.moveData.xPixels = O.xPixels;
      else {
        const D = t.pixelsToUnits({
          width: C.resizeData.widthPixels
        }).width;
        C.resizeData.widthPixels = t.unitsToPixels({
          width: D
        }).width;
      }
      m && (C.resizeData.heightPixels = O.heightPixels, C.moveData.yPixels = O.yPixels), M.push(O.gridItem);
    }), {
      resizedGridItems: M
    };
  }, T = (s) => {
    const g = S(s, { copyItems: !0, useUnits: !0 });
    R(g);
    const h = g.changes.map((P) => t.unitsToPixels(P.gridItem)), m = Eo(h);
    c(l).split("-").forEach((P) => {
      P === "left" ? m.left = s.right - m.width : P === "right" ? m.left = s.left : P === "top" ? m.top = s.bottom - m.height : P === "bottom" && (m.top = s.top);
    });
    const O = t.pixelsToUnits({
      x: m.left,
      y: m.top,
      width: m.width,
      height: m.height
    }), C = tn({
      gridItem: O,
      props: e
    });
    if (!e.allowOutOfBounds && C)
      return;
    const $ = new Set(b.map((P) => P.id)), D = Z(O);
    if (!e.allowOverlap && !e.moveOnCollision && Ce({
      boundingBox: D,
      gridItems: c(t.items),
      ignoreIds: $
    }).length)
      return;
    !e.allowOverlap && e.moveOnCollision && Ce({
      boundingBox: D,
      gridItems: c(t.items),
      ignoreIds: $
    }).length && Qe(
      O,
      c(t.items),
      $
    );
    const j = S(m, { useUnits: !0 });
    R(j), e.compact && et(c(t.items));
  }, E = (s, g = "bottom-right") => {
    p();
    const h = c(n.box);
    f = h, l.value = g, d = le(
      s,
      e.scale,
      c(t.gridLayoutRef)
    ), b = q(c(o.selectedGridItems)).map((M) => {
      const _ = t.unitsToPixels(M), O = (_.x - h.left) / h.width, C = (_.y - h.top) / h.height, $ = _.width / h.width, D = _.height / h.height;
      return {
        leftPct: O,
        topPct: C,
        widthPct: $,
        heightPct: D,
        ...M
      };
    }), s.preventDefault(), r.value = !0, i("resize-start", {
      boundingBox: h,
      position: l,
      items: b
    });
  }, v = (s) => {
    if (!c(r)) return;
    s.preventDefault();
    const { x: g, y: h } = le(
      s,
      e.scale,
      c(t.gridLayoutRef)
    ), m = xe(f);
    n.resize({
      boundingBox: m,
      position: l,
      resizeStart: d,
      resizeOnCenter: !1,
      preserveAspectRatio: !1,
      x: g,
      y: h
    });
    const M = S(m), { resizedGridItems: _ } = L(M);
    T(m), a.value = !0, _.length && x({
      boundingBox: m,
      items: q(_)
    });
  }, y = (s) => {
    var g;
    if (c(r) && !(((g = s == null ? void 0 : s.touches) == null ? void 0 : g.length) > 0)) {
      if (c(a)) {
        w();
        const h = b.filter((M) => {
          const _ = t.getItemById(M.id);
          return _ ? _.width !== M.width || _.height !== M.height || _.x !== M.x || _.y !== M.y : !1;
        }), m = !!(h != null && h.length);
        i("resize-end", {
          items: h
        }), m && t.onLayoutUpdated();
      }
      r.value = !1, a.value = !1, u();
    }
  }, p = () => {
    const s = { passive: !1 };
    document.addEventListener("mousemove", v), document.addEventListener("mouseup", y), document.addEventListener("touchmove", v, s), document.addEventListener("touchend", y);
  }, u = () => {
    document.removeEventListener("mousemove", v), document.removeEventListener("mouseup", y), document.removeEventListener("touchmove", v), document.removeEventListener("touchend", y);
  };
  return {
    isResizing: r,
    hasResized: a,
    position: l,
    onResizeStart: E
  };
}
function Hl({
  layout: e,
  selection: t,
  snapGrid: n,
  emit: o
}) {
  const i = G(null), r = A(() => {
    const f = To(c(t.selectedGridItems), (x) => {
      let w = je(x);
      return c(e.isUnitsTypePixels) || (w = e.unitsToPixels(w), x.moveData && (w.x = x.moveData.xPixels, w.y = x.moveData.yPixels), x.resizeData && (w.width = x.resizeData.widthPixels, w.height = x.resizeData.heightPixels)), w;
    });
    return f.length ? Eo(f) : null;
  }), a = we((f) => {
    It(() => {
      o("bounding-box-changed", {
        boundingBox: f,
        boundingBoxElement: c(i)
      });
    });
  }, Ke);
  k(r, a);
  const l = (f, b, x) => {
    const w = f;
    let S = x;
    c(e.isUnitsTypePixels) && c(n == null ? void 0 : n.grid) && (S = n.getSnapPoint({ [b]: x })[b]), w[b] = S;
    const R = w.bottom - w.top < 0, L = w.right - w.left < 0;
    R && b === "top" && (w.top = w.bottom), R && b === "bottom" && (w.bottom = w.top), L && b === "left" && (w.left = w.right), L && b === "right" && (w.right = w.left);
  };
  return {
    boundingBoxRef: i,
    box: r,
    resize: ({
      boundingBox: f,
      position: b,
      resizeStart: x,
      resizeOnCenter: w,
      preserveAspectRatio: S,
      x: R,
      y: L
    }) => {
      const T = f, E = f.height / f.width;
      let v, y;
      const p = () => (T.right - T.left) * E, u = () => {
        const g = (p() - T.height) / 2;
        T.top -= g, T.bottom += g;
      };
      c(b) === "top" ? (y = x.y - L, l(T, "top", T.top - y), w && (T.bottom += y)) : c(b) === "right" ? (v = R - x.x, l(T, "right", T.right + v), w && (T.left -= v)) : c(b) === "bottom" ? (y = L - x.y, l(T, "bottom", T.bottom + y), w && (T.top -= y)) : c(b) === "left" ? (v = x.x - R, l(T, "left", T.left - v), w && (T.right += v)) : c(b) === "top-left" ? (v = x.x - R, y = x.y - L, l(T, "left", T.left - v), w && (T.right += v), S ? w ? u() : T.top = T.bottom - p() : (l(T, "top", T.top - y), w && (T.bottom += y))) : c(b) === "top-right" ? (v = R - x.x, y = x.y - L, l(T, "right", T.right + v), w && (T.left -= v), S ? w ? u() : T.top = T.bottom - p() : (l(T, "top", T.top - y), w && (T.bottom += y))) : c(b) === "bottom-right" ? (v = R - x.x, y = L - x.y, l(T, "right", T.right + v), w && (T.left -= v), S ? w ? u() : T.bottom = T.top + p() : (l(T, "bottom", T.bottom + y), w && (T.top -= y))) : c(b) === "bottom-left" && (v = x.x - R, y = L - x.y, l(T, "left", T.left - v), w && (T.right += v), S ? w ? u() : T.bottom = T.top + p() : (l(T, "bottom", T.bottom + y), w && (T.top -= y))), T.width = T.right - T.left, T.height = T.bottom - T.top;
    }
  };
}
function Nl({
  props: e,
  layout: t,
  selection: n,
  context: o
}) {
  const i = A(() => {
    const l = c(n.selectedGridItems);
    return Po(l);
  }), r = A(() => {
    const l = c(i);
    return t.unitsToPixels({
      x: l.left,
      y: l.top,
      width: l.width,
      height: l.height
    });
  }), a = A(() => {
    var x, w;
    const l = c(o), d = c((x = l == null ? void 0 : l.move) == null ? void 0 : x.isMoving), f = c((w = l == null ? void 0 : l.resize) == null ? void 0 : w.isResizing);
    return !c(t.isUnitsTypePixels) && e.showPlaceholder && (d || f);
  });
  return {
    box: i,
    boxPixels: r,
    isVisible: a
  };
}
function Wl({
  props: e,
  layout: t,
  selection: n
}) {
  const o = G(!1), i = G(null);
  let r = null, a;
  ne(() => {
    L(), E();
  });
  const l = (v) => {
    v.preventDefault();
  }, d = A(
    () => e.allowSelectionBox && c(n.canSelect)
  );
  k(d, (v) => {
    v ? R() : L();
  }), k(o, (v) => {
    v || E();
  });
  const f = () => {
    document.body.classList.add(jn);
    const v = window.getSelection();
    v && v.removeAllRanges();
  }, b = () => {
    document.body.classList.remove(jn);
  }, x = (v) => {
    if (!c(d)) {
      o.value = !1;
      return;
    }
    const y = v.target.closest(Ut), p = !Mo(v.button) && v.button !== 0;
    if (y || p) {
      o.value = !1;
      return;
    }
    if (e.selectionIgnore && v.target.closest(e.selectionIgnore)) {
      o.value = !1;
      return;
    }
    if (e.selectionContainer) {
      const g = v.target.closest(e.selectionContainer);
      if (!g) {
        o.value = !1;
        return;
      }
      if (!Rl(v, g)) {
        o.value = !1;
        return;
      }
      if (g !== a) {
        a = g;
        const m = { passive: !1 };
        a.addEventListener(
          "touchmove",
          l,
          m
        );
      }
    }
    f();
    const { x: u, y: s } = le(
      v,
      e.scale,
      c(t.gridLayoutRef)
    );
    r = {
      startX: u,
      startY: s
    }, i.value = {
      left: u,
      top: s,
      width: 0,
      height: 0,
      right: u,
      bottom: s
    }, o.value = !0, T();
  }, w = (v) => {
    if (!c(o))
      return;
    const { x: y, y: p } = le(
      v,
      e.scale,
      c(t.gridLayoutRef)
    ), { startX: u, startY: s } = r, g = y - u, h = p - s, m = Math.abs(g), M = Math.abs(h), _ = u + g, O = s + h, C = Math.min(u, _), $ = Math.min(s, O);
    i.value = {
      left: C,
      top: $,
      width: m,
      height: M,
      right: C + m,
      bottom: $ + M
    };
  }, S = (v) => {
    var s;
    if (b(), !c(o) || ((s = v == null ? void 0 : v.touches) == null ? void 0 : s.length) > 0) return;
    const y = c(i), p = c(t.items).map((g) => {
      let h = je(g);
      return c(t.isUnitsTypePixels) || (h = t.unitsToPixels(h)), h;
    }).filter((g) => {
      const h = So(g);
      return Qt(h, y);
    });
    if (Xc(() => {
      o.value = !1;
    }), p.some((g) => !n.isSelected(g.id))) {
      const g = c(t.itemsById), h = p.map((C) => g[C.id]), m = c(t.keyCommands).selection, { multipleSelect: M } = m, _ = K(M, v), O = e.allowMultiselect && _;
      n.selectGridItems(h, O);
    }
  }, R = () => {
    L(), document.addEventListener("mousedown", x), document.addEventListener("touchstart", x);
  }, L = () => {
    document.removeEventListener("mousedown", x), document.removeEventListener("touchstart", x), a && a.removeEventListener("touchmove", l);
  }, T = () => {
    E(), document.addEventListener("mousemove", w), document.addEventListener("mouseup", S), document.addEventListener("touchmove", w), document.addEventListener("touchend", S);
  }, E = () => {
    document.removeEventListener("mousemove", w), document.removeEventListener("mouseup", S), document.removeEventListener("touchmove", w), document.removeEventListener("touchend", S);
  };
  return De(() => {
    c(d) && R();
  }), {
    box: i,
    isSelecting: o,
    isEnabled: d
  };
}
function Gl({
  props: e,
  layout: t,
  selection: n,
  emit: o
}) {
  const i = (d) => {
    if (!e.allowDelete) return;
    const f = [];
    d.forEach((b) => {
      var S;
      const x = t.getItemById(b.id);
      if (!((S = x == null ? void 0 : x.props) != null && S.allowDelete)) return;
      const w = c(t.items).findIndex((R) => R.id === b.id);
      w !== -1 && c(t.items).splice(w, 1), delete c(t.itemsById)[b.id], f.push(x), n.clearSelection([b.id]);
    }), e.compact && et(c(t.items)), o("items-deleted", {
      items: q(f)
    }), t.onLayoutUpdated();
  }, r = (d) => {
    const f = c(t.keyCommands).delete.deleteItem;
    K(f, d) && e.allowDelete && !d.target.closest(e.deleteIgnore) && (d.preventDefault(), i(c(n.selectedGridItems)));
  }, a = () => {
    l(), document.addEventListener("keyup", r);
  }, l = () => {
    document.removeEventListener("keyup", r);
  };
  return De(() => {
    e.allowDelete && a();
  }), ne(() => {
    l();
  }), k(() => e.allowDelete, (d) => {
    d ? a() : l();
  }), {
    deleteItems: i
  };
}
function Fl({
  props: e,
  layout: t,
  selection: n
}) {
  const o = (v) => me(
    v.filter((y) => {
      var p;
      return (p = y.props) == null ? void 0 : p.allowMoveZ;
    }),
    "z"
  ), i = () => me(c(t.items), "z"), r = (v) => {
    const y = Dt(v).z;
    return c(t.items).every((u) => v.find((g) => g.id === u.id) || u.z > y);
  }, a = (v) => {
    const y = ee(v).z;
    return c(t.items).every((u) => v.find((g) => g.id === u.id) || u.z < y);
  }, l = (v) => (v == null ? void 0 : v.length) && !a(v), d = (v) => (v == null ? void 0 : v.length) && !r(v), f = ({
    movableItems: v,
    itemsSortedByZ: y
  }) => {
    const p = (s) => s ? !!v.find((g) => g.id === (s == null ? void 0 : s.id)) : !1, u = [];
    for (let s = 0; s < y.length; s += 1) {
      const g = y[s];
      if (p(g)) {
        const h = [g];
        let m = y[s + 1];
        for (; p(m); )
          h.push(m), s += 1, m = y[s + 1];
        u.push(h);
      }
    }
    return u;
  }, b = () => {
    const v = c(n.selectedGridItems), y = o(v), p = c(t.itemsSortedByZ), u = f({
      itemsSortedByZ: p,
      movableItems: y
    });
    return {
      selectedGridItems: v,
      movableItems: y,
      itemsSortedByZ: p,
      moveGroups: u
    };
  }, x = () => {
    const { movableItems: v } = b();
    if (!l(v))
      return;
    let y = !1;
    v.forEach((p) => {
      const u = i(), s = p, g = bl({
        itemsOrderedByZ: u,
        currentZPosition: p.z
      });
      g !== s.z && (s.z = g, y = !0);
    }), y && t.onLayoutUpdated();
  }, w = () => {
    const { movableItems: v } = b();
    if (!d(v))
      return;
    const y = [...v].reverse();
    let p = !1;
    y.forEach((u) => {
      const s = i(), g = u, h = Tl({
        itemsOrderedByZ: s,
        currentZPosition: u.z
      });
      h !== g.z && (g.z = h, p = !0);
    }), p && t.onLayoutUpdated();
  }, S = () => {
    const {
      movableItems: v,
      itemsSortedByZ: y,
      moveGroups: p
    } = b();
    if (!l(v))
      return;
    let u = !1;
    p.forEach((s) => {
      const g = Dt(s).z, h = Ml({
        itemsSortedByZ: y,
        currentZPosition: g,
        numPositions: s.length
      });
      s.forEach((m, M) => {
        const _ = m;
        _.z = h[M], u = !0;
      });
    }), u && t.onLayoutUpdated();
  }, R = () => {
    const {
      movableItems: v,
      itemsSortedByZ: y,
      moveGroups: p
    } = b();
    if (!d(v))
      return;
    let u = !1;
    p.reverse().forEach((s) => {
      const g = ee(s).z, h = _l({
        itemsSortedByZ: y,
        currentZPosition: g,
        numPositions: s.length
      });
      s.reverse().forEach((m, M) => {
        const _ = m;
        _.z = h[M], u = !0;
      });
    }), u && t.onLayoutUpdated();
  }, L = (v) => {
    const y = c(n.selectedGridItems);
    if (!(y != null && y.length))
      return;
    const {
      moveToFront: p,
      moveForward: u,
      moveBackward: s,
      moveToBack: g
    } = c(t.keyCommands).move, h = K(p, v), m = K(u, v), M = K(s, v), _ = K(g, v);
    !(h || _ || m || M) || !(e.allowMoveZ && !v.target.closest(e.moveIgnore)) || (v.preventDefault(), h ? x() : _ ? w() : m ? S() : M && R());
  }, T = () => {
    E(), document.addEventListener("keydown", L);
  }, E = () => {
    document.removeEventListener("keydown", L);
  };
  return De(() => {
    e.allowMoveZ && T();
  }), ne(() => {
    E();
  }), k(() => e.allowMoveZ, (v) => {
    v ? T() : E();
  }), {
    moveToFront: x,
    moveToBack: w,
    moveForward: S,
    moveBackward: R
  };
}
function Xl({ props: e, id: t }) {
  const n = () => {
    if (o(), !e.allowMove)
      return;
    const i = document.createElement("style");
    i.setAttribute(Kn, t), i.innerHTML = `
      [data-grid-id="${t}"].${nl} .${_o} ${e.moveIgnore} {
        cursor: auto;
      }
    `, document.head.appendChild(i);
  }, o = () => {
    const i = document.querySelector(`style[${Kn}="${t}"]`);
    i && i.remove();
  };
  k(() => e.moveIgnore, n), k(() => e.allowMove, n), De(() => {
    n();
  }), ne(() => {
    o();
  });
}
function Yl({
  props: e
}) {
  const t = A(() => e.snapGrid ? {
    ...Te,
    ...e.snapGrid
  } : null);
  return {
    grid: t,
    getSnapPoint: (o) => {
      const i = c(t);
      return Object.keys(o).reduce((a, l) => {
        const f = l === "left" || l === "right" ? i.cellWidth : i.cellHeight, b = o[l], x = Math.round(b / f);
        return a[l] = x * f, a;
      }, {});
    }
  };
}
const kl = /* @__PURE__ */ Object.assign({
  name: "SelectionBox"
}, {
  __name: "SelectionBox",
  props: {
    selectionBox: {
      type: Object,
      required: !0
    },
    scale: {
      type: Number,
      default: 1
    }
  },
  setup(e) {
    const t = e, n = A(
      () => c(t.selectionBox.isEnabled) && c(t.selectionBox.isSelecting)
    ), o = A(() => {
      var l;
      return c((l = t.selectionBox) == null ? void 0 : l.box);
    }), i = A(() => 1 / t.scale), r = A(() => ({
      ...c(o),
      width: c(o).width / c(i),
      height: c(o).height / c(i)
    })), a = A(() => {
      const l = c(r);
      return {
        left: `${l.left}px`,
        top: `${l.top}px`,
        width: `${l.width}px`,
        height: `${l.height}px`,
        transform: `scale(${c(i)})`
      };
    });
    return (l, d) => n.value ? (W(), he("div", {
      key: 0,
      style: ze(a.value),
      class: "titan-grid-selection-box"
    }, null, 4)) : J("", !0);
  }
}), Oo = {
  color: {
    platform: {
      neutral: {
        500: "#a3a3a3"
      }
    }
  },
  space: {
    "8x": "64px"
  }
}, Zl = { class: "titan-grid-snap-grid" }, ql = {
  "pointer-events": "none",
  width: "100%",
  height: "100%",
  xmlns: "http://www.w3.org/2000/svg"
}, Vl = ["width", "height"], Jl = ["d", "stroke", "stroke-width"], Ql = ["width", "height", "x", "y"], eu = ["width", "height"], tu = ["d", "stroke", "stroke-width"], nu = /* @__PURE__ */ re("rect", {
  width: "100%",
  height: "100%",
  fill: "url(#grid)"
}, null, -1), ou = /* @__PURE__ */ Object.assign({
  name: "SnapGrid"
}, {
  __name: "SnapGrid",
  props: {
    borderRadius: {
      type: Number,
      default: 0
    },
    cellWidth: {
      type: Number,
      default: Te.cellWidth
    },
    cellHeight: {
      type: Number,
      default: Te.cellHeight
    },
    cellLargeWidthCellCount: {
      type: Number,
      default: Te.cellLargeWidthCellCount
    },
    cellLargeHeightCellCount: {
      type: Number,
      default: Te.cellLargeHeightCellCount
    },
    lineColor: {
      type: String,
      default: Oo.color.platform.neutral[500]
    },
    cellLineWidth: {
      type: Number,
      default: Te.cellLineWidth
    },
    largeCellLineWidth: {
      type: Number,
      default: Te.largeCellLineWidth
    },
    isRtl: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    Gn((r) => ({
      "5a51138e": i.value
    }));
    const t = e, n = A(() => t.cellLargeWidthCellCount * t.cellWidth), o = A(() => t.cellLargeHeightCellCount * t.cellHeight), i = A(() => `${t.borderRadius}px`);
    return (r, a) => (W(), he("div", Zl, [
      (W(), he("svg", ql, [
        re("defs", null, [
          re("pattern", {
            id: "smallGrid",
            width: t.cellWidth,
            height: t.cellHeight,
            patternUnits: "userSpaceOnUse"
          }, [
            re("path", {
              d: `M ${t.cellWidth} 0 L 0 0 0 ${t.cellHeight}`,
              fill: "none",
              stroke: t.lineColor,
              "stroke-width": t.cellLineWidth
            }, null, 8, Jl)
          ], 8, Vl),
          re("pattern", {
            id: "grid",
            width: n.value,
            height: o.value,
            patternUnits: "userSpaceOnUse",
            x: t.isRtl ? "100%" : void 0,
            y: t.isRtl ? "0%" : void 0
          }, [
            re("rect", {
              width: n.value,
              height: o.value,
              fill: "url(#smallGrid)"
            }, null, 8, eu),
            re("path", {
              d: `M ${n.value} 0 L 0 0 0 ${o.value}`,
              fill: "none",
              stroke: t.lineColor,
              "stroke-width": t.largeCellLineWidth
            }, null, 8, tu)
          ], 8, Ql)
        ]),
        nu
      ]))
    ]));
  }
}), iu = /* @__PURE__ */ Object.assign({
  name: "GridPlaceholder"
}, {
  __name: "GridPlaceholder",
  props: {
    placeholder: {
      type: Object,
      required: !0
    }
  },
  setup(e) {
    const t = e, n = A(() => {
      const o = c(t.placeholder.boxPixels);
      return {
        left: `${o.x}px`,
        top: `${o.y}px`,
        width: `${o.width}px`,
        height: `${o.height}px`
      };
    });
    return (o, i) => t.placeholder.isVisible.value ? (W(), he("div", {
      key: 0,
      class: "titan-grid-placeholder",
      style: ze(n.value)
    }, null, 4)) : J("", !0);
  }
}), ye = /* @__PURE__ */ Object.assign({
  name: "ResizeHandle"
}, {
  __name: "ResizeHandle",
  props: {
    /*
      top-left,
      top,
      top-right,
      right,
      bottom-right,
      bottom,
      bottom-left,
      left
    */
    position: {
      type: String,
      default: "bottom-right"
    },
    context: {
      type: Object,
      required: !0
    }
  },
  setup(e) {
    const t = e, n = (o) => {
      t.context.resize.onResizeStart(o, t.position);
    };
    return (o, i) => (W(), he("div", {
      class: Be(["titan-grid-resize-handle", {
        [`titan-grid-resize-handle--${t.position}`]: t.position
      }]),
      onMousedown: i[0] || (i[0] = Ge((r) => n(r), ["left"])),
      onTouchstart: i[1] || (i[1] = (r) => n(r))
    }, null, 34));
  }
}), ru = /* @__PURE__ */ Object.assign({
  name: "RotationDegrees"
}, {
  __name: "RotationDegrees",
  props: {
    context: {
      type: Object,
      required: !0
    },
    size: {
      type: String,
      default: "m"
    }
  },
  setup(e) {
    const t = e;
    return (n, o) => (W(), he("div", {
      class: Be(["titan-grid-rotation-degrees", {
        "titan-grid-rotation-degrees--is-visible": t.context.rotate.isRotating.value,
        [`titan-grid-rotation-degrees--${e.size}`]: e.size
      }])
    }, Bo(`${t.context.rotate.rotationDegrees.value}°`), 3));
  }
}), su = /* @__PURE__ */ Object.assign({
  name: "RotationHandle"
}, {
  __name: "RotationHandle",
  props: {
    context: {
      type: Object,
      required: !0
    }
  },
  setup(e) {
    const t = e, n = A(() => {
      const i = c(t.context.boundingBox.box);
      if (!i) return null;
      const r = 1 / t.context.props.scale, a = i.width / r, d = i.height / r / 2, f = a + cl;
      return {
        top: `${d}px`,
        left: `${f}px`
      };
    }), o = (i) => {
      t.context.rotate.onRotateStart(i);
    };
    return (i, r) => (W(), he("div", {
      style: ze(n.value),
      class: "titan-grid-rotation"
    }, [
      re("div", {
        class: Be(["titan-grid-rotation__handle", {
          "titan-grid-rotation__handle--is-rotating": t.context.rotate.isRotating.value
        }]),
        onMousedown: r[0] || (r[0] = Ge((a) => o(a), ["left"])),
        onTouchstart: r[1] || (r[1] = (a) => o(a))
      }, [
        at(Do(Ho), {
          "symbol-id": "rotate",
          size: "s"
        })
      ], 34)
    ], 4));
  }
}), au = /* @__PURE__ */ Object.assign({
  name: "BoundingBox",
  inheritAttrs: !1
}, {
  __name: "BoundingBox",
  props: {
    context: {
      type: Object,
      required: !0
    }
  },
  setup(e) {
    const t = parseInt(Oo.space["8x"], 10), n = e, o = (f) => {
      const { boundingBox: b } = n.context;
      b.boundingBoxRef.value = f;
    }, i = A(() => {
      var f;
      return c((f = n.context.boundingBox) == null ? void 0 : f.box);
    }), r = A(() => 1 / n.context.props.scale), a = A(() => ({
      ...c(i),
      width: c(i).width / c(r),
      height: c(i).height / c(r)
    })), l = A(() => {
      const f = c(a);
      return Math.min(f.width, f.height) >= t ? "m" : "s";
    }), d = A(() => {
      const f = c(a);
      return {
        left: `${f.left}px`,
        top: `${f.top}px`,
        width: `${f.width}px`,
        height: `${f.height}px`,
        transform: `scale(${c(r)})`
      };
    });
    return (f, b) => (W(), he("div", {
      ref: o,
      class: Be(["titan-grid-bounding-box", {
        "titan-grid-bounding-box--is-rotating": n.context.rotate.isRotating.value
      }]),
      style: ze(d.value)
    }, [
      n.context.selection.allowResize.value ? (W(), oe(ye, {
        key: 0,
        position: "top-left",
        context: n.context
      }, null, 8, ["context"])) : J("", !0),
      n.context.selection.allowResizeY.value ? (W(), oe(ye, {
        key: 1,
        position: "top",
        context: n.context
      }, null, 8, ["context"])) : J("", !0),
      n.context.selection.allowResize.value ? (W(), oe(ye, {
        key: 2,
        position: "top-right",
        context: n.context
      }, null, 8, ["context"])) : J("", !0),
      n.context.selection.allowResizeX.value ? (W(), oe(ye, {
        key: 3,
        position: "right",
        context: n.context
      }, null, 8, ["context"])) : J("", !0),
      n.context.selection.allowResize.value ? (W(), oe(ye, {
        key: 4,
        position: "bottom-right",
        context: n.context
      }, null, 8, ["context"])) : J("", !0),
      n.context.selection.allowResizeY.value ? (W(), oe(ye, {
        key: 5,
        position: "bottom",
        context: n.context
      }, null, 8, ["context"])) : J("", !0),
      n.context.selection.allowResize.value ? (W(), oe(ye, {
        key: 6,
        position: "bottom-left",
        context: n.context
      }, null, 8, ["context"])) : J("", !0),
      n.context.selection.allowResizeX.value ? (W(), oe(ye, {
        key: 7,
        position: "left",
        context: n.context
      }, null, 8, ["context"])) : J("", !0),
      at(ru, {
        context: n.context,
        size: l.value
      }, null, 8, ["context", "size"]),
      n.context.layout.allowRotate.value ? (W(), oe(su, {
        key: 8,
        context: n.context
      }, null, 8, ["context"])) : J("", !0)
    ], 6));
  }
}), cu = ["data-grid-id"], gu = /* @__PURE__ */ Object.assign({
  name: "GridLayout"
}, {
  __name: "GridLayout",
  props: {
    unitsType: {
      type: String,
      default: We
      // pixels, custom
    },
    items: {
      type: Array,
      default: () => []
    },
    columns: {
      type: Number,
      default: null
    },
    rows: {
      type: Number,
      default: 0
    },
    rowHeight: {
      type: Number,
      default: 1
    },
    margin: {
      type: Object,
      default: () => ({ x: 0, y: 0 })
    },
    autoSize: {
      type: Boolean,
      default: !1
    },
    compact: {
      type: Boolean,
      default: !1
    },
    scale: {
      type: Number,
      default: 1
    },
    showPlaceholder: {
      type: Boolean,
      default: !1
    },
    moveOnCollision: {
      type: Boolean,
      default: !1
    },
    allowDelete: {
      type: Boolean,
      default: !0
    },
    allowOutOfBounds: {
      type: Boolean,
      default: !0
    },
    allowOverlap: {
      type: Boolean,
      default: !0
    },
    allowMultiselect: {
      type: Boolean,
      default: !0
    },
    allowRotate: {
      type: Boolean,
      default: !0
    },
    allowResize: {
      type: Boolean,
      default: !0
    },
    allowMove: {
      type: Boolean,
      default: !0
    },
    allowMoveZ: {
      type: Boolean,
      default: !0
    },
    allowAnimation: {
      type: Boolean,
      default: !0
    },
    allowSelectionBox: {
      type: Boolean,
      default: !0
    },
    selectionContainer: {
      type: String,
      default: "body"
    },
    selectionIgnore: {
      type: String,
      default: ul
    },
    deleteIgnore: {
      type: String,
      default: dl
    },
    moveIgnore: {
      type: String,
      default: fl
    },
    snapGrid: {
      type: Object,
      default: null
    },
    keyCommands: {
      type: Object,
      default: null
    }
  },
  emits: [
    "layout-changed",
    "height-changed",
    "rotation-start",
    "rotation-change",
    "rotation-end",
    "resize-start",
    "resize-change",
    "resize-end",
    "move-start",
    "move-change",
    "move-end",
    "selection-changed",
    "bounding-box-changed",
    "items-deleted",
    "item-mousedown"
  ],
  setup(e, { expose: t, emit: n }) {
    Gn((y) => ({
      "023e57aa": v.value
    }));
    const o = e, i = n, r = G(null), a = Uo(null), l = Yl({
      props: o
    }), d = $l({
      props: o,
      gridLayoutRef: r,
      snapGrid: l.grid,
      emit: i,
      context: a
    }), f = zl({
      props: o,
      layout: d,
      emit: i
    }), b = Gl({
      props: o,
      layout: d,
      selection: f,
      emit: i
    }), x = Fl({
      props: o,
      layout: d,
      selection: f
    }), w = Nl({
      props: o,
      layout: d,
      selection: f,
      context: a
    }), S = Hl({
      layout: d,
      selection: f,
      snapGrid: l,
      emit: i
    }), R = Wl({
      props: o,
      layout: d,
      selection: f
    }), L = Ul({
      props: o,
      layout: d,
      boundingBox: S,
      selection: f,
      emit: i
    });
    Xl({ props: o, id: d.id });
    const T = () => {
      const y = c(a);
      y && ["move", "resize"].forEach((s) => {
        var h;
        const g = (h = y[s]) == null ? void 0 : h.onDestroy;
        g && g();
      });
      let p;
      o.unitsType === We ? p = Bl({
        props: o,
        layout: d,
        selection: f,
        boundingBox: S,
        snapGrid: l,
        emit: i
      }) : p = Dl({
        props: o,
        layout: d,
        selection: f,
        boundingBox: S,
        emit: i
      });
      let u;
      o.unitsType === We ? u = Kl({
        props: o,
        layout: d,
        boundingBox: S,
        selection: f,
        snapGrid: l,
        emit: i
      }) : u = jl({
        props: o,
        layout: d,
        boundingBox: S,
        selection: f,
        emit: i
      }), a.value = {
        boundingBox: S,
        delete: b,
        layout: d,
        move: p,
        moveZ: x,
        placeholder: w,
        resize: u,
        rotate: L,
        selection: f,
        selectionBox: R,
        snapGrid: l,
        props: o
      };
    };
    T(), k(() => o.unitsType, T);
    const E = A(() => {
      const y = c(a), p = c(y.layout.layoutHeightPixels);
      let u = "100%";
      return o.unitsType === We && o.columns && (u = `${o.columns}px`), {
        height: `${p}px`,
        width: u
      };
    }), v = A(() => {
      const y = c(a);
      if (c(y.resize.isResizing))
        return ll[c(y.resize.position)];
      if (c(y.rotate.isRotating))
        return "grabbing";
    });
    return t({
      id: d.id,
      context: a,
      props: o
    }), (y, p) => {
      var u, s, g, h, m, M, _;
      return W(), he("div", {
        "data-grid-id": a.value.layout.id,
        class: Be(["titan-grid-layout", {
          "titan-grid-layout--is-selecting": (u = a.value.selectionBox) == null ? void 0 : u.isSelecting.value
        }]),
        ref_key: "gridLayoutRef",
        ref: r,
        style: ze(E.value)
      }, [
        Fe(y.$slots, "default"),
        Fe(y.$slots, "items", { context: a.value }),
        (g = (s = a.value.boundingBox) == null ? void 0 : s.box) != null && g.value ? (W(), oe(au, {
          key: 0,
          context: a.value
        }, null, 8, ["context"])) : J("", !0),
        at(kl, {
          "selection-box": a.value.selectionBox,
          scale: o.scale
        }, null, 8, ["selection-box", "scale"]),
        (m = (h = a.value.snapGrid.grid) == null ? void 0 : h.value) != null && m.showGrid ? (W(), oe(ou, Ko(jo({ key: 1 }, (_ = (M = a.value.snapGrid) == null ? void 0 : M.grid) == null ? void 0 : _.value)), null, 16)) : J("", !0),
        at(iu, {
          placeholder: a.value.placeholder
        }, null, 8, ["placeholder"])
      ], 14, cu);
    };
  }
});
export {
  hu as GridItem,
  gu as GridLayout,
  Tl as createBottomZPosition,
  bl as createTopZPosition
};
//# sourceMappingURL=titan-grid-layout.js.map
